(function () {
    'use strict';

    const {
      setScrollbarWidth
    } = window.PoleneLibs.Utils;
    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return keyboardNavigation; }), Promise.resolve().then(function () { return dropdown$1; }), Promise.resolve().then(function () { return reveal$1; }), Promise.resolve().then(function () { return togglePreOrderBlock$1; }), Promise.resolve().then(function () { return wishlist$1; }), Promise.resolve().then(function () { return countrySelectorModal$1; }), Promise.resolve().then(function () { return bisForm$1; }), Promise.resolve().then(function () { return bisModal$1; }), Promise.resolve().then(function () { return eventForm$1; }), Promise.resolve().then(function () { return main; }), Promise.resolve().then(function () { return componentCarousel$1; }), Promise.resolve().then(function () { return componentModal$1; }), Promise.resolve().then(function () { return componentTabs$1; }), Promise.resolve().then(function () { return componentProductCard$1; }), Promise.resolve().then(function () { return componentProductForm$1; }), Promise.resolve().then(function () { return componentDrawer$1; }), Promise.resolve().then(function () { return componentSlider$1; }), Promise.resolve().then(function () { return componentAccordion$1; }), Promise.resolve().then(function () { return componentNewsletterSignup$1; }), Promise.resolve().then(function () { return componentAddToWishlist$1; }), Promise.resolve().then(function () { return componentSnackbar$1; }), Promise.resolve().then(function () { return componentAccordion$1; }), Promise.resolve().then(function () { return wishlistCounter$1; }), Promise.resolve().then(function () { return wishlistGrid$1; }), Promise.resolve().then(function () { return wishlistStateBlock$1; }), Promise.resolve().then(function () { return fragmentCartNotification$1; }), Promise.resolve().then(function () { return fragmentCursor$1; }), Promise.resolve().then(function () { return fragmentOptionSelect$1; }), Promise.resolve().then(function () { return fragmentRevealableItems$1; }), Promise.resolve().then(function () { return fragmentSearchTrigger$1; }), Promise.resolve().then(function () { return fragmentSubMenu$1; }), Promise.resolve().then(function () { return fragmentVideo$1; }), Promise.resolve().then(function () { return handleNewsletterEvent; }), Promise.resolve().then(function () { return imageLoaded$1; }), Promise.resolve().then(function () { return parallax$1; }), Promise.resolve().then(function () { return sectionAnnouncementBar$1; }), Promise.resolve().then(function () { return sectionArticleTeaser$1; }), Promise.resolve().then(function () { return sectionHeader$1; }), Promise.resolve().then(function () { return sectionCountdownTeaser$1; }), Promise.resolve().then(function () { return sectionProductRecommendations$1; }), Promise.resolve().then(function () { return sectionWishlistSlider$1; })];
        const componentsObj = hydrateComponents(components, setScrollbarWidth);
        await componentsObj.hydrate?.();
      })();
    });

    function initKeyboardNavigation() {
      const handleMouseDown = () => {
        document.body.classList.remove('keyboard-navigation');
      };
      const handleKeyDown = e => {
        if (e.key === 'Tab') {
          document.body.classList.add('keyboard-navigation');
        }
      };
      document.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    document.addEventListener('DOMContentLoaded', initKeyboardNavigation);

    var keyboardNavigation = /*#__PURE__*/Object.freeze({
        __proto__: null,
        initKeyboardNavigation: initKeyboardNavigation
    });

    const {
      getRefs: getRefs$d,
      getElementsByRef: getElementsByRef$d
    } = window.PoleneLibs.Refs;
    const initDropdown = dropdown => {
      const ref = getRefs$d(dropdown);
      const KEYS = {
        SPACEBAR: [0, 32],
        ENTER: 13,
        DOWN_ARROW: 40,
        UP_ARROW: 38,
        ESCAPE: 27
      };
      if (!ref.items) return;
      if (dropdown.dataset.dropdown === 'store-selector') {
        const currentStore = ref.items.find(item => {
          const link = item.querySelector('a');
          return link?.href?.includes(location.hostname);
        });
        if (currentStore) {
          ref.selected.textContent = currentStore.textContent;
        }
      }
      ref.selected.addEventListener('click', e => toggleVisibility(e));
      ref.selected.addEventListener('keydown', e => toggleVisibility(e));
      document.body.addEventListener('click', e => handleBodyClick(e));
      const handleBodyClick = e => {
        const clickOutsideDropdown = !e.target.closest('[data-ref="dropdown"]');
        if (clickOutsideDropdown) close();
      };
      const handleClose = e => {
        setSelected(e);
        close();
      };
      const handleKeypress = e => {
        switch (e.keyCode) {
          case KEYS.ENTER:
            handleClose(e);
            return;
          case KEYS.DOWN_ARROW:
            focusNextItem(KEYS.DOWN_ARROW);
            return;
          case KEYS.UP_ARROW:
            focusNextItem(KEYS.UP_ARROW);
            return;
          case KEYS.ESCAPE:
            close();
            return;
          default:
            return;
        }
      };
      const itemTeardowns = ref.items.map(item => {
        item.addEventListener('click', handleClose);
        item.addEventListener('keydown', handleKeypress);
        return () => {
          item.removeEventListener('click', handleClose);
          item.removeEventListener('keydown', handleKeypress);
        };
      });
      function setSelected(e) {
        ref.selected.textContent = e.target.innerText;
      }
      function close() {
        ref.list.classList.remove('open');
        ref.container.setAttribute('aria-expanded', false);
        ref.container.hidden = true;
        ref.root.focus();
      }
      function toggleVisibility(e) {
        let openDropDown = KEYS.SPACEBAR.includes(e.keyCode) || e.keyCode === KEYS.ENTER;
        if (e.keyCode === KEYS.ESCAPE) close();
        if (e.type === 'click' || openDropDown) {
          ref.list.classList.toggle('open');
          ref.container.setAttribute('aria-expanded', ref.list.classList.contains('open'));
          ref.container.hidden = false;
        }
        if (e.keyCode === KEYS.DOWN_ARROW) {
          focusNextItem(KEYS.DOWN_ARROW);
        }
        if (e.keyCode === KEYS.UP_ARROW) {
          focusNextItem(KEYS.UP_ARROW);
        }
      }
      function focusNextItem(direction) {
        if (!ref.list.classList.contains('open')) {
          return;
        }
        const activeElement = document.activeElement;
        const activeElementId = activeElement instanceof HTMLElement ? activeElement.dataset?.id : undefined;
        if (activeElementId === 'selected') {
          ref.items[0].focus();
          return;
        }
        const activeItem = ref.items.findIndex(item => item.dataset.id === activeElementId);
        if (direction === KEYS.DOWN_ARROW) {
          const isLastItem = activeItem < ref.items.length - 1;
          if (isLastItem) {
            const nextListItemId = ref.items[activeItem + 1].dataset.id;
            ref.items.find(item => item.dataset.id === nextListItemId).focus();
          }
        }
        if (direction === KEYS.UP_ARROW) {
          const isFirstItem = activeItem > 0;
          if (isFirstItem) {
            const nextListItemId = ref.items[activeItem - 1].dataset.id;
            ref.items.find(item => item.dataset.id === nextListItemId).focus();
          }
        }
      }
      return () => {
        itemTeardowns.forEach(teardown => teardown());
      };
    };
    var dropdown = () => {
      const {
        dropdown
      } = getElementsByRef$d(['dropdown']);
      if (!dropdown) return;
      const elements = Array.isArray(dropdown) ? dropdown : [dropdown];
      const instances = elements.map(initDropdown);
      return () => {
        instances.forEach(teardown => teardown?.());
      };
    };

    var dropdown$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: dropdown
    });

    var reveal = () => {
      const {
        getElementsByRef
      } = window.PoleneLibs.Refs;
      const {
        revealElement
      } = getElementsByRef('reveal-element');
      if (!revealElement) return;
      const items = Array.isArray(revealElement) ? Array.from(revealElement) : [revealElement];
      const init = () => {
        items.forEach(item => item.classList.add('is-revealed'));
      };
      init();
    };

    var reveal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: reveal
    });

    var togglePreOrderBlock = window.addEventListener('PRODUCT_CARD_RENDERED', () => {
      const variantInPreorder = document.querySelectorAll('.variant-selector__variant.is-preorder');
      const disabledPreorder = document.querySelectorAll('.variant-selector__variant:not(.is-preorder)');
      if (variantInPreorder.length > 0) {
        variantInPreorder.forEach(variant => {
          const variantInformations = variant.dataset;
          const preorderInfoBlock = document.querySelector(`#preorder-${variantInformations.pid}`);
          if (preorderInfoBlock) {
            variant.addEventListener('mouseenter', function () {
              if ('pod' in variantInformations && variantInformations.pod && variantInformations.pod !== '' && 'pofd' in variantInformations && variantInformations.pofd && variantInformations.pofd !== '') {
                const preorderInput = variant.closest('.product-card')?.querySelector('input#pre-order');
                const preorderTagInput = variant.closest('.product-card')?.querySelector('input#pre-order-tag');
                const preorderDateInput = variant.closest('.product-card')?.querySelector('input#pre-order-date');
                updatePreOrderInfoBlock({
                  pofd: variantInformations.pofd,
                  preorderInfoBlock: preorderInfoBlock
                });
                if (preorderInput && preorderTagInput && preorderDateInput) {
                  [{
                    preorderInput: preorderInput,
                    name: `properties[${window.translations?.preorder}]`,
                    value: variantInformations.pofd
                  }, {
                    preorderInput: preorderTagInput,
                    name: `properties[_is_preorder]`,
                    value: 'true'
                  }, {
                    preorderInput: preorderDateInput,
                    name: `properties[_preorder_date]`,
                    value: variantInformations.pod
                  }].forEach(e => updatePreOrderInput(e));
                }
              } else {
                emptyPreorderInfoBlock({
                  preorderInfoBlock: preorderInfoBlock
                });
              }
            });
            variant.addEventListener('mouseleave', function () {
              emptyPreorderInfoBlock({
                preorderInfoBlock: preorderInfoBlock
              });
            });
          }
        });
      }
      if (disabledPreorder.length > 0) {
        disabledPreorder.forEach(variant => {
          const variantInformations = variant.dataset;
          const preorderInfoBlock = document.querySelector(`#preorder-${variantInformations.pid}`);
          variant.addEventListener('mouseover', function () {
            if (preorderInfoBlock) {
              const preorderInput = variant.closest('.product-card')?.querySelector('input#pre-order');
              const preorderTagInput = variant.closest('.product-card')?.querySelector('input#pre-order-tag');
              const preorderDateInput = variant.closest('.product-card')?.querySelector('input#pre-order-date');
              if (preorderInput && preorderTagInput && preorderDateInput) {
                [{
                  preorderInput: preorderInput,
                  name: '',
                  value: ''
                }, {
                  preorderInput: preorderTagInput,
                  name: '',
                  value: ''
                }, {
                  preorderInput: preorderDateInput,
                  name: '',
                  value: ''
                }].forEach(e => updatePreOrderInput(e));
              }
              emptyPreorderInfoBlock({
                preorderInfoBlock: preorderInfoBlock
              });
            }
          });
        });
      }
      window.addEventListener('TRIGGER_NOTIFICATION_LAYOUT', event => {
        const detail = event.detail;
        if (detail) {
          const preorderInput = detail.element.querySelector('input#pre-order');
          const preorderTag = detail.element.querySelector('input#pre-order-tag');
          const preorderDate = detail.element.querySelector('input#pre-order-date');
          const product_variants = detail.element.querySelectorAll('.variant-selector__variant');
          if (preorderInput && product_variants && preorderTag && preorderDate) {
            product_variants.forEach(variant => {
              variant.addEventListener('click', () => {
                if ('pofd' in variant.dataset && variant.dataset.pofd && variant.dataset.pofd !== '' && variant.dataset.pod) {
                  [{
                    preorderInput: preorderInput,
                    value: variant.dataset.pofd,
                    name: `properties[${window.translations?.preorder}]`
                  }, {
                    preorderInput: preorderTag,
                    value: 'true',
                    name: `properties[_is_preorder]`
                  }, {
                    preorderInput: preorderDate,
                    value: variant.dataset.pod,
                    name: `properties[_preorder_date]`
                  }].forEach(e => updatePreOrderInput(e));
                } else {
                  [{
                    preorderInput: preorderInput,
                    value: '',
                    name: ''
                  }, {
                    preorderInput: preorderTag,
                    value: '',
                    name: ''
                  }, {
                    preorderInput: preorderDate,
                    value: '',
                    name: ''
                  }].forEach(e => updatePreOrderInput(e));
                }
              });
            });
          }
        }
      });
      function emptyPreorderInfoBlock({
        preorderInfoBlock
      }) {
        preorderInfoBlock.innerHTML = '';
      }
      function updatePreOrderInfoBlock({
        pofd,
        preorderInfoBlock
      }) {
        emptyPreorderInfoBlock({
          preorderInfoBlock: preorderInfoBlock
        });
        preorderInfoBlock.innerHTML = `
			<span class="ts-label-s js-preorder-title">${window.translations?.preorder}</span>
			<span class="ts-label-s ts-grey js-preorder-info">${pofd}</span>
		`;
      }
      function updatePreOrderInput({
        preorderInput,
        value,
        name
      }) {
        preorderInput?.setAttribute('name', name);
        preorderInput?.setAttribute('value', value);
      }
      return () => {};
    });

    var togglePreOrderBlock$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: togglePreOrderBlock
    });

    const PROXY_BASE_PATH = '/apps/polene-theme-features';
    const KLAVIYO_BASE_PATH = 'https://a.klaviyo.com/client';
    const KLAVIYO_ID = window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const API_PROXY = {
      RETURNS: PROXY_BASE_PATH + '/order-returns',
      RETURN_BUTTON: PROXY_BASE_PATH + '/order-return-button',
      ORDER_HISTORY: PROXY_BASE_PATH + '/order-history',
      ORDER_DETAILS: PROXY_BASE_PATH + '/order-details',
      DELETE_ACCOUNT: PROXY_BASE_PATH + '/delete-account',
      CREATE_CUSTOMER: PROXY_BASE_PATH + '/customer-create',
      UPDATE_CUSTOMER: PROXY_BASE_PATH + '/customer-update',
      CUSTOMER_SMS_CONSENT: PROXY_BASE_PATH + '/customer-sms-marketing',
      CUSTOMER_WISHLIST: PROXY_BASE_PATH + '/customer-wishlist',
      STOREFRONT: PROXY_BASE_PATH + '/storefront',
      MARKETING_SUBSCRIBE: PROXY_BASE_PATH + '/marketing-subscribe',
      BACK_IN_STOCK_SUBSCRIBE: PROXY_BASE_PATH + '/back-in-stock-subscribe',
      WISHLIST: PROXY_BASE_PATH + '/wishlist'
    };
    const API_KLAVIYO = {
      HEADERS: {
        'revision': '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      BACK_IN_STOCK_SUB: KLAVIYO_BASE_PATH + `/back-in-stock-subscriptions/?company_id=${KLAVIYO_ID}`,
      SUBSCRIPTION: KLAVIYO_BASE_PATH + `/subscriptions?company_id=${KLAVIYO_ID}`,
      EVENT: KLAVIYO_BASE_PATH + `/profiles?company_id=${KLAVIYO_ID}`
    };
    const FOCUSABLE_SELECTORS = ['button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'].join(', ');
    const IS_WEBKIT = typeof window !== 'undefined' && /apple/i.test(navigator.vendor);

    var WishlistEvent;
    (function (WishlistEvent) {
      WishlistEvent[WishlistEvent["UPDATE"] = 0] = "UPDATE";
      WishlistEvent[WishlistEvent["ADD"] = 1] = "ADD";
      WishlistEvent[WishlistEvent["REMOVE"] = 2] = "REMOVE";
    })(WishlistEvent || (WishlistEvent = {}));

    class Wishlist {
      static CACHE_EXPIRATION_AGE = 0;
      static productIds = [];
      static initialized = false;
      static localId = undefined;
      static eventHandlers = {
        [WishlistEvent.UPDATE]: [],
        [WishlistEvent.ADD]: [],
        [WishlistEvent.REMOVE]: []
      };
      static async init() {
        if (this.initialized) return;
        this.authenticate();
        if (this.localId) {
          this.setupEndpoint();
          if (!this.loadFromCache()) await this.get();
          this.callback(WishlistEvent.UPDATE);
        }
        this.initialized = true;
      }
      static cache = () => {
        localStorage.setItem('wishlist_products', JSON.stringify(Array.isArray(this.productIds) ? this.productIds : []));
        localStorage.setItem('wishlist_products_timestamp', Date.now().toString());
      };
      static authenticate = () => {
        const localId = localStorage.getItem('local_id');
        if (localId) this.localId = localId;else if (window.location.href.includes('wishlist')) this.registerLocally();
      };
      static registerLocally = () => {
        this.localId = self.crypto.randomUUID();
        localStorage.setItem('local_id', this.localId);
        this.setupEndpoint();
      };
      static setupEndpoint = () => {
        const root = window?.Shopify?.routes?.root || '/';
        const path = `${root}${API_PROXY.WISHLIST.replace(/^\/+/, '')}`;
        this.endpoint = `${path}?local_id=${this.localId}`;
      };
      static loadFromCache() {
        const cached = localStorage.getItem('wishlist_products');
        const timestamp = localStorage.getItem('wishlist_products_timestamp');
        if (cached && timestamp) {
          const age = Date.now() - parseInt(timestamp);
          this.productIds = JSON.parse(cached);
          if (age < this.CACHE_EXPIRATION_AGE) return true;
        }
        return false;
      }
      static callback = event => {
        const ids = [...this.productIds];
        if (Array.isArray(event)) {
          event.forEach(e => this.eventHandlers[e].forEach(func => func(ids)));
        } else this.eventHandlers[event].forEach(func => func(ids));
      };
      static async request(endpoint, options = {}) {
        try {
          const response = await fetch(endpoint, options);
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          const data = await response.json();
          return {
            data
          };
        } catch (error) {
          const message = error instanceof Error ? error.message : 'Unknown error';
          return {
            error: message
          };
        }
      }
      static getHTML = async (type = 'grid') => {
        try {
          const response = await fetch(`${this.endpoint}&type=${type}`, {
            headers: {
              Accept: 'text/html'
            }
          });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          const data = await response.text();
          return data;
        } catch (error) {
          error instanceof Error ? error.message : 'Unknown error';
          return '';
        }
      };
      static get = async () => {
        if (!this.localId) this.registerLocally();
        const result = await this.request(this.endpoint);
        if (result.data) {
          this.productIds = result.data.products;
          this.cache();
        }
        return this.productIds;
      };
      static add = async productId => {
        if (!this.localId) this.registerLocally();
        if (this.productIds.includes(productId)) return true;
        const formData = new FormData();
        formData.append('product_id', productId);
        const result = await this.request(`${this.endpoint}`, {
          method: 'POST',
          body: formData
        });
        if (result.data?.success) {
          this.productIds.push(productId);
          this.cache();
          this.callback([WishlistEvent.ADD, WishlistEvent.UPDATE]);
          return true;
        }
        return false;
      };
      static remove = async productId => {
        if (!this.localId) return false;
        if (!this.productIds.includes(productId)) return true;
        const formData = new FormData();
        formData.append('product_id', productId);
        const result = await this.request(this.endpoint, {
          method: 'DELETE',
          body: formData
        });
        if (result.data?.success) {
          this.productIds = this.productIds.filter(id => id !== productId);
          this.cache();
          this.callback([WishlistEvent.REMOVE, WishlistEvent.UPDATE]);
          return true;
        }
        return false;
      };
      static count = () => this.productIds.length;
      static isInWishlist = productId => {
        return this.productIds.includes(productId);
      };
      static getProductIds = () => {
        return [...this.productIds];
      };
      static setEventListeners = (event, callback) => this.eventHandlers[event].push(callback);
      static removeEventListeners = (event, callback) => this.eventHandlers[event] = this.eventHandlers[event].filter(func => func !== callback);
    }
    var wishlist = async () => await Wishlist.init();

    var wishlist$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Wishlist: Wishlist,
        default: wishlist
    });

    const SEARCH_PARAM = 'openCountrySelector';
    const CLOSE_BUTTON_SELECTOR = '.country-selector__popup__header__close';
    const focusLock = window.PoleneVendors.focusLock;
    class CountrySelectorModal {
      constructor() {
        this.selectorModals = document.querySelectorAll('.selector_popup');
        this.selectorButtons = document.querySelectorAll('.selector-button');
        this.boundHandleEscapeKeydown = this.handleEscapeKeydown.bind(this);
        this.boundHandleButtonClick = this.handleButtonClick.bind(this);
        this.boundCloseModal = this.closeModal.bind(this);
      }
      handleButtonClick(event) {
        const button = event.currentTarget;
        const countrySelectorModal = document.querySelector(`#${button.dataset.puid}`);
        if (countrySelectorModal && !document.body.classList.contains('search-open')) {
          this.showModal(countrySelectorModal);
        }
      }
      showModal(countrySelectorModal) {
        if (!countrySelectorModal) return;
        const closeModalButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
        if (closeModalButton) {
          closeModalButton.addEventListener('click', this.boundCloseModal);
        }
        document.addEventListener('keydown', this.boundHandleEscapeKeydown);
        countrySelectorModal.classList.add('is-open');
        document.querySelector('body')?.classList.add('country-selector-modal-is-open');
        countrySelectorModal.setAttribute('tabindex', '0');
        focusLock.on(countrySelectorModal);
      }
      closeModal() {
        const countrySelectorModal = document.querySelector('.selector_popup.is-open');
        if (countrySelectorModal) {
          countrySelectorModal.classList.remove('is-open');
          document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
          focusLock.off(countrySelectorModal);
          this.clearEvents(countrySelectorModal);
          const url = new URL(window.location.href);
          const urlParams = new URLSearchParams(url.search);
          urlParams.delete(SEARCH_PARAM);
          url.search = urlParams.toString();
          window.history.replaceState({}, document.title, url.toString());
        }
      }
      clearEvents(countrySelectorModal) {
        const modalCloseButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
        document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
        if (modalCloseButton) {
          modalCloseButton.removeEventListener('click', this.boundCloseModal);
        }
      }
      handleEscapeKeydown(event) {
        if (event.key === 'Escape') {
          this.closeModal();
        }
      }
      getSearchParam() {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        urlParams.delete('country');
        url.search = urlParams.toString();
        window.history.replaceState({}, document.title, url.toString());
        return urlParams.has(SEARCH_PARAM);
      }
      setupEventListeners() {
        if (!this.selectorModals || this.selectorButtons.length === 0) return;
        this.selectorButtons.forEach(button => {
          button.addEventListener('click', this.boundHandleButtonClick);
        });
      }
      cleanup() {
        if (this.selectorButtons) {
          this.selectorButtons.forEach(button => {
            button.removeEventListener('click', this.boundHandleButtonClick);
          });
        }
        document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
        if (this.selectorModals) {
          this.selectorModals.forEach(modal => {
            if (modal.classList.contains('is-open')) {
              this.clearEvents(modal);
              focusLock.off(modal);
              modal.classList.remove('is-open');
            }
          });
        }
        document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
      }
      init() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.setupEventListeners();
          });
        } else {
          this.setupEventListeners();
        }
        if (this.getSearchParam()) {
          const defaultModal = this.selectorModals[0];
          if (defaultModal) {
            this.showModal(defaultModal);
          }
        }
        return this.cleanup.bind(this);
      }
    }
    var countrySelectorModal = () => {
      const modal = new CountrySelectorModal();
      return modal.init();
    };

    var countrySelectorModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CountrySelectorModal: CountrySelectorModal,
        default: countrySelectorModal
    });

    const validateEmail = email => {
      if (/^[\w+.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        return true;
      }
      return false;
    };

    const events$9 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$7
    } = window.PoleneLibs.Utils;
    const {
      getElementsByRef: getElementsByRef$c,
      getRefs: getRefs$c
    } = window.PoleneLibs.Refs;
    const {
      storeLanguage: storeLanguage$1
    } = window.PoleneLibs.ConstantsDate;
    const states$1 = {
      submitted: 'submitted',
      error: 'error',
      noEmail: 'no-email'
    };
    const selectors$a = {
      bisForm: '.js-bis-form',
      bisContainer: '.js-bis-container'
    };
    var bisForm = () => {
      const {
        bis
      } = getElementsByRef$c('bis');
      if (!bis || Array.isArray(bis)) return;
      const bisContainers = bis ? Array.isArray(bis) ? bis : [bis] : [];
      let newsletterConsent;
      const init = () => {
        newsletterConsent = bis.querySelector('input[id="newsletter-checkbox"]');
        setEventListeners();
      };
      const setEventListeners = () => {
        window.addEventListener(events$9.TOGGLE_BIS, handleBisData);
        bisContainers.forEach(bis => {
          const {
            bisForm
          } = getRefs$c(bis);
          if (bisForm) {
            bisForm.addEventListener('submit', handleSubmit);
          }
        });
      };
      const handleBisData = e => {
        const {
          variantId
        } = e.detail;
        bisContainers.forEach(bis => {
          const {
            bisForm
          } = getRefs$c(bis);
          if (bisForm) {
            bisForm.dataset.variantId = variantId || '';
          }
        });
      };
      const requestBackInStockSubscription = async (email, variantId, emailMarketingConsent) => {
        const formData = new FormData();
        formData.set('email', email);
        formData.set('locale', storeLanguage$1);
        formData.set('email_marketing_consent', JSON.stringify(emailMarketingConsent));
        formData.set('variant_id', variantId);
        return fetch(`${API_PROXY.BACK_IN_STOCK_SUBSCRIBE}`, {
          method: 'POST',
          body: formData
        });
      };
      const handleSubmit = async e => {
        e.preventDefault();
        const bisForm = e.target.closest(selectors$a.bisForm);
        const bisContainer = e.target.closest(selectors$a.bisContainer);
        const {
          variantId
        } = e.target.dataset;
        const {
          bisEmail
        } = getRefs$c(bisForm);
        if (!bisEmail.value || !validateEmail(bisEmail.value)) {
          bis.dataset.state = states$1.noEmail;
          return;
        }
        try {
          const response = await requestBackInStockSubscription(bisEmail.value, variantId, newsletterConsent?.checked ?? false);
          if (response.status === 202) {
            bisContainer.dataset.state = states$1.submitted;
            updateBackInStockSubscriptions(variantId);
          } else {
            bisContainer.dataset.state = states$1.error;
          }
        } catch (error) {
          bisContainer.dataset.state = states$1.error;
        }
      };
      const updateBackInStockSubscriptions = variantId => {
        const storageKey = 'back-in-stock-subscriptions';
        let backInStockSubscriptions = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!backInStockSubscriptions.includes(variantId)) {
          backInStockSubscriptions.push(variantId);
          localStorage.setItem(storageKey, JSON.stringify(backInStockSubscriptions));
        }
        dispatchEvent$7(window, events$9.UPDATE_BIS, {
          variantId
        });
      };
      init();
      return () => {
        window.removeEventListener(events$9.TOGGLE_BIS, handleBisData);
        bisContainers.forEach(bis => {
          const {
            bisForm
          } = getRefs$c(bis);
          if (bisForm) {
            bisForm.removeEventListener('submit', handleSubmit);
          }
        });
      };
    };

    var bisForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: bisForm
    });

    const events$8 = window.PoleneLibs.Events.default;
    const scrollLock$4 = window.PoleneLibs.ScrollLock.default;
    const {
      dispatchEvent: dispatchEvent$6
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$i,
      getElementsByRef: getElementsByRef$b,
      getRefs: getRefs$b
    } = window.PoleneLibs.Refs;
    const selectors$9 = {
      image: '.js-zoom-image',
      bg: '.js-bg',
      close: '.js-close',
      submitBtn: '.js-submit-btn',
      zoomedImg: '.js-zoomed-img'
    };
    const classes$b = {
      modalOpen: 'modal-open',
      visible: 'is-visible'
    };
    const types = {
      zoom: {
        name: 'image-zoom',
        config: {
          modalClose: true
        }
      },
      bis: {
        name: 'bis',
        config: {
          modalClose: true
        }
      }
    };
    var bisModal = () => {
      const {
        modal,
        bis
      } = getElementByRef$i(['modal', 'bis']);
      const {
        modalTrigger
      } = getElementsByRef$b(['modal-trigger']);
      if (!modal) return;
      let zoomImage;
      let modalOpen = false;
      let type;
      let previousActiveElement = null;
      let focusableElements = null;
      const {
        imageContainer
      } = getRefs$b(modal);
      const triggers = modalTrigger ? Array.isArray(modalTrigger) ? [...modalTrigger] : [modalTrigger] : [];
      let variantId = undefined;
      const init = () => {
        setEventlisteners();
      };
      const initFocusableElements = () => {
        if (!bis) return;
        focusableElements = Array.from(bis.querySelectorAll(FOCUSABLE_SELECTORS));
      };
      const setEventlisteners = () => {
        modal.addEventListener('click', handleClick);
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener(events$8.TOGGLE_BIS, handleToggleBis);
        window.addEventListener(events$8.UPDATE_BIS, () => {
          updateModalContent(true);
        });
        if (triggers.length) {
          triggers.forEach(trigger => {
            trigger.addEventListener('click', handleClick);
            if (trigger.dataset.imagesrc) {
              trigger.addEventListener('mouseenter', handleMouseOver);
              trigger.addEventListener('mouseleave', handleMouseLeave);
            }
          });
        }
      };
      const handleToggleBis = event => {
        if (event.detail.variantId) variantId = event.detail.variantId;
        type = types.bis;
        toggleModal(true, type);
      };
      const handleClick = e => {
        e.stopPropagation();
        const image = e.target.closest(selectors$9.image);
        const bg = e.target.closest(selectors$9.bg);
        const close = e.target.closest(selectors$9.close);
        const zoomed = e.target.closest(selectors$9.zoomedImg);
        const bisTrigger = e.target.closest('.js-bis-trigger');
        if (bisTrigger && bisTrigger.dataset.variantId) {
          variantId = bisTrigger.dataset.variantId;
          type = types.bis;
          toggleModal(true, type);
          return;
        }
        if (image) {
          type = types.zoom;
          toggleModal(true, type);
          handleImageZoom(image.dataset.imagesrc);
        }
        if (bg) {
          if (type && type.config.modalClose) {
            toggleModal(false);
          }
        }
        if (close || zoomed) {
          toggleModal(false);
        }
      };
      const handleKeyDown = e => {
        if (e.key === 'Escape' && modalOpen) {
          toggleModal(false);
        } else if (e.key === 'Tab' && modalOpen) {
          manageFocus(e);
        }
      };
      const manageFocus = e => {
        if (!focusableElements?.length) return;
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const isTabbing = !e.shiftKey;
        const isReverseTabbing = e.shiftKey;
        if (isReverseTabbing && document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        } else if (isTabbing && document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      };
      const toggleModal = (state, type) => {
        modalOpen = state;
        scrollLock$4(modalOpen);
        let hideForm = variantIsSubscribed(variantId) ? true : false;
        updateModalContent(hideForm);
        if (modalOpen) {
          previousActiveElement = document.activeElement;
          document.body.classList.add(classes$b.modalOpen);
          document.body.dataset.modal = type.name;
          requestAnimationFrame(() => {
            if (bis) {
              bis.setAttribute('aria-hidden', 'false');
              initFocusableElements();
              const closeButton = bis.querySelector('.js-close');
              setTimeout(() => {
                closeButton?.focus();
              }, 1000);
            }
          });
        } else {
          if (imageContainer) {
            zoomImage = null;
            imageContainer.innerHTML = '';
            dispatchEvent$6(window, events$8.CHANGE_CURSOR, {
              type: 'default',
              contrast: false
            });
          }
          document.body.classList.remove(classes$b.modalOpen);
          if (bis) {
            bis.setAttribute('aria-hidden', 'true');
          }
          previousActiveElement?.focus();
          focusableElements = null;
        }
      };
      const handleMouseOver = () => {
        dispatchEvent$6(window, events$8.CHANGE_CURSOR, {
          type: 'zoom',
          contrast: true
        });
      };
      const handleMouseLeave = () => {
        if (!modalOpen) {
          dispatchEvent$6(window, events$8.CHANGE_CURSOR, {
            type: 'default',
            contrast: false
          });
        }
      };
      const handleImageZoom = image => {
        imageContainer.getBoundingClientRect();
        dispatchEvent$6(window, events$8.CHANGE_CURSOR, {
          type: 'close',
          contrast: true
        });
        zoomImage = document.createElement('img');
        zoomImage.setAttribute('class', 'modal__zoom-img js-zoomed-img');
        zoomImage.setAttribute('src', image);
        imageContainer.appendChild(zoomImage);
      };
      const updateModalContent = hide => {
        const form = modal.querySelector('form.js-bis-form');
        const formInput = modal.querySelector('div.form-input');
        const formButton = modal.querySelector(selectors$9.submitBtn);
        const formContainer = modal.querySelector('.js-bis-container');
        const formNewsletter = modal.querySelector('.bis-form__newsletter');
        if (formInput && formButton && formContainer && form && formNewsletter) {
          formInput.classList.toggle('is-hidden', hide);
          formButton.classList.toggle('is-hidden', hide);
          form.classList.toggle('is-hidden', hide);
          formNewsletter.classList.toggle('is-hidden', hide);
          if (hide === true) {
            formContainer.dataset.state = 'submitted';
          } else {
            formContainer.dataset.state = '';
          }
        }
      };
      const variantIsSubscribed = productId => {
        return getBackInStockSubscriptions().includes(productId);
      };
      const getBackInStockSubscriptions = () => {
        const storageKey = 'back-in-stock-subscriptions';
        let backInStockSubscriptions = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return backInStockSubscriptions;
      };
      init();
      return () => {
        modal.removeEventListener('click', handleClick);
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener(events$8.TOGGLE_BIS, handleToggleBis);
        window.removeEventListener(events$8.UPDATE_BIS, () => {
          updateModalContent(true);
        });
        if (triggers.length) {
          triggers.forEach(trigger => {
            trigger.removeEventListener('click', handleClick);
            if (trigger.dataset.imagesrc) {
              trigger.removeEventListener('mouseenter', handleMouseOver);
              trigger.removeEventListener('mouseleave', handleMouseLeave);
            }
          });
        }
      };
    };

    var bisModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: bisModal
    });

    var InputFields;
    (function (InputFields) {
      InputFields["FirstName"] = "firstName";
      InputFields["LastName"] = "lastName";
      InputFields["Address1"] = "address1";
      InputFields["Address2"] = "address2";
      InputFields["Zip"] = "zip";
      InputFields["City"] = "city";
      InputFields["Phone"] = "phone";
      InputFields["Birthdate"] = "birthdate";
      InputFields["email"] = "email";
      InputFields["password"] = "password";
      InputFields["confirmPassword"] = "confirmPassword";
      InputFields["civility"] = "civility";
    })(InputFields || (InputFields = {}));
    const FormSelectors = {
      Customer: {
        BIRTHDATE: 'input[name=birthdate]',
        PHONE: 'input[name="phone"]',
        PHONE_COUNTRY_SELECT: 'select[name="phone_country_select"]',
        SUBMIT_BUTTON: 'button[type="submit"]',
        FIRST_NAME: 'input[name="firstName"]',
        LAST_NAME: 'input[name="lastName"]',
        EMAIL: 'input[name="email"]',
        PASSWORD: 'input[name="password"]',
        CIVILITY: 'select[name="civility"]',
        Shopify: {
          Selectors: {
            EMAIL: 'input[name="customer[email]"]',
            PASSWORD: 'input[name="customer[password]"]',
            CONFIRM_PASSWORD: 'input[name="customer[password_confirmation]"]'
          }
        },
        RecoverPassword: {
          EMAIL: 'input[name="email"]'
        },
        Update: {
          ID: '#profile_form',
          FORM: '#update_customer_form',
          Selectors: {
            FIRST_NAME: 'input[name="firstName"]',
            LAST_NAME: 'input[name="lastName"]',
            PHONE: 'input[name="phone"]'
          },
          Fields: {
            FirstName: 'firstName',
            LastName: 'lastName',
            Phone: 'phone'
          }
        },
        Address: {
          COUNTRY_SELECT: 'select[name="address[country]"]',
          PHONE: 'input[name="address[phone]"]',
          FIRST_NAME: 'input[name="address[first_name]"]',
          LAST_NAME: 'input[name="address[last_name]"]',
          ADDRESS_1: 'input[name="address[address1]"]',
          ADDRESS_2: 'input[name="address[address2]"]',
          ZIP: 'input[name="address[zip]"]',
          CITY: 'input[name="address[city]"]'
        }
      }
    };
    const defaultNoValidationConf = {
      noSpecialChar: undefined,
      nonLatinCharacters: undefined,
      noNumber: undefined,
      maxLength: undefined,
      minLength: 0,
      required: false
    };
    const inputTextDefaultValidationConf = {
      nonLatinCharacters: true,
      noSpecialChar: true,
      noNumber: true,
      maxLength: 35,
      minLength: 0,
      required: true
    };
    const FormValidations = {
      [InputFields.FirstName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.LastName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.Address1]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: true
      },
      [InputFields.Address2]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: false
      },
      [InputFields.City]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: undefined,
        required: true
      },
      [InputFields.Zip]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: 10,
        required: true
      },
      [InputFields.Phone]: {
        ...defaultNoValidationConf
      },
      [InputFields.email]: {
        ...defaultNoValidationConf,
        required: true
      },
      [InputFields.password]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.confirmPassword]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.civility]: {
        ...defaultNoValidationConf,
        required: true
      },
      [InputFields.Birthdate]: {
        ...inputTextDefaultValidationConf,
        nonLatinCharacters: false,
        noSpecialChar: false,
        maxDate: Date.now(),
        required: false,
        noNumber: false
      }
    };

    var ErrorTypes;
    (function (ErrorTypes) {
      ErrorTypes["invalidTitle"] = "invalid_title";
      ErrorTypes["invalidName"] = "invalid_name";
      ErrorTypes["invalidCivility"] = "invalid_civility";
      ErrorTypes["nonLatinCharacters"] = "contains_non_latin_characters";
      ErrorTypes["maxLengthExceeded"] = "max_length_exceeded";
      ErrorTypes["minLength"] = "min_length";
      ErrorTypes["containsNumbers"] = "contains_numbers";
      ErrorTypes["containsSpecialChars"] = "contains_special_chars";
      ErrorTypes["empty"] = "empty";
      ErrorTypes["phoneNumberInvalid"] = "phone_number_invalid";
      ErrorTypes["formSubmitError"] = "form_error";
      ErrorTypes["TAKEN"] = "email_taken";
      ErrorTypes["maxDate"] = "max_date";
      ErrorTypes["invalidDate"] = "invalid_date";
    })(ErrorTypes || (ErrorTypes = {}));

    const containsNonLatinCharactersFieldError = str => {
      const nonLatinRegex = /[^\u0000-\u017F]+/;
      return nonLatinRegex.test(str || '');
    };
    const validateNotContainsNonLatinCharacters = str => {
      if (containsNonLatinCharactersFieldError(str)) {
        return {
          isValid: false,
          error: ErrorTypes.nonLatinCharacters
        };
      }
      return {
        isValid: true
      };
    };
    function validateMaxLength(str, maxLength) {
      if (str.length > maxLength) {
        return {
          isValid: false,
          error: ErrorTypes.maxLengthExceeded
        };
      }
      return {
        isValid: true
      };
    }
    function validateMinLength(str, minLength) {
      if (str.length < minLength) {
        return {
          isValid: false,
          error: ErrorTypes.minLength
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoNumbers(str) {
      const numberRegex = /\d/;
      if (numberRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsNumbers
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoSpecialChars(str) {
      const specialCharsRegex = /[%_;|]/;
      if (specialCharsRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsSpecialChars
        };
      }
      return {
        isValid: true
      };
    }
    function validateNotEmpty(str) {
      const withoutWhiteSpace = str.replace(/\s/g, '');
      if (withoutWhiteSpace.length <= 0) return {
        isValid: false,
        error: ErrorTypes.empty
      };
      return {
        isValid: true
      };
    }
    function validateMaxDate(inputTimestamp, limitTimestamp) {
      if (inputTimestamp > limitTimestamp) {
        return {
          isValid: false,
          error: ErrorTypes.maxDate
        };
      }
      return {
        isValid: true
      };
    }
    function validateDate(ts) {
      return !ts ? {
        isValid: false,
        error: ErrorTypes.invalidDate
      } : {
        isValid: true
      };
    }

    const DateFormat = window.PoleneLibs.DateFormat;
    class InputValidation {
      inputs = {};
      dateFormat = new DateFormat();
      hasSubmitOnce = false;
      constructor({
        formContainer,
        inputs
      }) {
        this.formContainer = formContainer;
        this.inputs = inputs;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw new Error('Form not found');
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Submit Button not found');
      }
      triggerValidationEffect(input, validation) {
        if (!validation.isValid && validation.error) {
          this.displayErrorSpan(input, validation.error, validation.message);
          if (this.submitButton) this.submitButton.disabled = true;
          return false;
        }
        this.removeErrorSpan(input);
        if (this.submitButton) this.submitButton.disabled = false;
        return true;
      }
      displayErrorSpan(input, error, message) {
        this.removeErrorSpan(input);
        const errorSpan = this.form?.querySelector(`span[data-ref=${input.id}-${error}]`);
        if (!errorSpan) return;
        if (message) errorSpan.textContent = message;
        input.ariaInvalid = 'true';
        input.setAttribute('aria-describedby', `${input.id}-${error}`);
        errorSpan.hidden = false;
        errorSpan.style.display = 'block';
      }
      removeErrorSpan(input) {
        const errorSpans = this.form?.querySelectorAll(`span[data-ref^=${input.id}]`);
        if (!errorSpans) return;
        input.ariaInvalid = 'false';
        input.removeAttribute('aria-describedby');
        errorSpans.forEach(span => {
          span.hidden = true;
          span.style.display = 'none';
        });
      }
      checkRequiredInput({
        input
      }) {
        if (!input) return true;
        let inputIsEmpty = false;
        if (!input.validationConfig.required) return;
        const emptyCheck = validateNotEmpty(input.selector.value);
        if (!this.triggerValidationEffect(input.selector, emptyCheck)) return false;
        inputIsEmpty = true;
        return inputIsEmpty;
      }
      checkRequiredInputs({
        inputs
      }) {
        if (!inputs) return false;
        let isValid = true;
        Object.values(this.inputs).forEach(input => {
          if (!input.validationConfig.required) return;
          const emptyCheck = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, emptyCheck)) {
            isValid = false;
          }
        });
        return isValid;
      }
      validateInput(input) {
        if (this.hasSubmitOnce) {
          const empty = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, empty)) {
            return false;
          }
        }
        if (input.selector.dataset.ref == 'input-date' && input.selector.value != `${this.dateFormat.placeholder}  (${input.selector.dataset.tOptional})`) {
          const date = this.dateFormat.parse(input.selector.value);
          const invalidDateCheck = validateDate(date);
          if (!this.triggerValidationEffect(input.selector, invalidDateCheck)) return false;
          if (input.validationConfig.maxDate) {
            const maxDateCheck = validateMaxDate(date ?? NaN, input.validationConfig.maxDate);
            if (!this.triggerValidationEffect(input.selector, maxDateCheck)) return false;
          }
        }
        if (input.validationConfig.noSpecialChar) {
          const speCharCheck = validateNoSpecialChars(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, speCharCheck)) {
            return false;
          }
        }
        if (input.validationConfig.noNumber) {
          const noNumb = validateNoNumbers(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, noNumb)) {
            return false;
          }
        }
        if (input.validationConfig.maxLength) {
          const lengthCheck = validateMaxLength(input.selector.value, input.validationConfig.maxLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.minLength) {
          const lengthCheck = validateMinLength(input.selector.value, input.validationConfig.minLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.nonLatinCharacters) {
          const latinCharactersCheck = validateNotContainsNonLatinCharacters(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, latinCharactersCheck)) {
            return false;
          }
        }
        return true;
      }
      validateForm({
        inputs
      }) {
        let isValid = true;
        Object.values(inputs).forEach(input => {
          if (input.selector.value.trim() !== '') {
            if (!this.validateInput(input)) {
              isValid = false;
            }
          }
        });
        return isValid;
      }
    }

    const {
      getElementByRef: getElementByRef$h
    } = window.PoleneLibs.Refs;
    const handleNewsletterEventSubscription = async formData => {
      let customerIsSubscribedToEvent = true;
      const errorType = ErrorTypes.formSubmitError;
      let errorMessage;
      const {
        newsletterEventForm,
        messageContainerSuccess,
        messageContainerError,
        messageContainerAlreadySignedUp
      } = getElementByRef$h(['newsletter-event-form', 'message-container-success', 'message-container-error', 'message-container-already-signed-up']);
      if (!newsletterEventForm || !messageContainerSuccess || !messageContainerError || !messageContainerAlreadySignedUp) {
        customerIsSubscribedToEvent = false;
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      }
      const {
        eventKey
      } = newsletterEventForm.dataset;
      const customerEmail = formData.get('email');
      if (typeof customerEmail != 'string') {
        messageContainerError.style.display = 'block';
        customerIsSubscribedToEvent = false;
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      } else {
        try {
          const response = await fetch(API_KLAVIYO.EVENT, {
            method: 'POST',
            headers: API_KLAVIYO.HEADERS,
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email: customerEmail,
                  meta: {
                    patch_properties: {
                      append: {
                        event: eventKey
                      }
                    }
                  }
                }
              }
            })
          });
          if (response.status === 202) {
            messageContainerSuccess.style.display = 'block';
            newsletterEventForm.querySelector('input[data-ref="event-form-email"]').value = '';
          } else {
            messageContainerError.style.display = 'block';
          }
        } catch (error) {
          customerIsSubscribedToEvent = false;
        }
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      }
    };

    var handleNewsletterEvent = /*#__PURE__*/Object.freeze({
        __proto__: null,
        handleNewsletterEventSubscription: handleNewsletterEventSubscription
    });

    const {
      getElementsByRef: getElementsByRef$a
    } = window.PoleneLibs.Refs;
    class NewsletterEventForm {
      inputs = {};
      constructor({
        formContainerId
      }) {
        this.formContainer = document.getElementById(formContainerId);
        if (!this.formContainer) throw `Unable to find form container with id: ${formContainerId}`;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw `Unable to find form in the given container: ${formContainerId}`;
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Required elements not found');
        this.inputs = {
          email: {
            selector: this.form.querySelector(FormSelectors.Customer.EMAIL),
            validationConfig: FormValidations.email
          }
        };
        this.init();
      }
      initInputValidation({
        inputs
      }) {
        this.inputValidation = new InputValidation({
          formContainer: this.formContainer,
          inputs: inputs
        });
      }
      handleFormValidation = () => {
        if (!this.inputs.email?.selector) return false;
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleInputValidation = input => {
        if (!input.selector || !input.validationConfig) return false;
        const isValid = this.inputValidation?.validateInput(input);
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      async handleFormSubmit(event) {
        event.preventDefault();
        if (!this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        }) || !this.handleFormValidation) return false;
        const form = event.currentTarget;
        const formData = new FormData(form);
        if (this.submitButton) this.submitButton.disabled = true;
        const newsletterEventSubscriptionHandler = await handleNewsletterEventSubscription(formData);
        if (this.submitButton) {
          if (!newsletterEventSubscriptionHandler.customerIsSubscribedToEvent) {
            this.inputValidation?.triggerValidationEffect(this.submitButton, {
              isValid: newsletterEventSubscriptionHandler.customerIsSubscribedToEvent,
              error: newsletterEventSubscriptionHandler.errorType,
              message: newsletterEventSubscriptionHandler.errorMessage
            });
          }
          this.submitButton.disabled = !newsletterEventSubscriptionHandler.customerIsSubscribedToEvent;
        }
      }
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => {
          return input.selector.addEventListener('blur', () => this.handleInputValidation(input));
        });
      }
      destroy() {
        this.form.removeEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', () => this.handleInputValidation(input)));
      }
    }
    var eventForm = async () => {
      const newsletterEventForm = getElementsByRef$a('newsletter-event-form');
      if (newsletterEventForm) {
        try {
          const form = new NewsletterEventForm({
            formContainerId: 'newsletter-event-form-container'
          });
          return () => {
            form.destroy();
          };
        } catch (error) {}
      }
    };

    var eventForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: eventForm
    });

    class Accordion {
      static currentOpen = null;
      constructor(domNode, autoClose, autoSetHiddenAttribute) {
        this.autoClose = autoClose;
        this.autoSetHiddenAttribute = autoSetHiddenAttribute;
        this.rootEl = domNode;
        this.buttonEl = this.rootEl?.querySelector('button[aria-expanded]') ?? undefined;
        const controlsId = this.buttonEl?.getAttribute('aria-controls') ?? undefined;
        this.contentEl = controlsId ? document.getElementById(controlsId) : undefined;
        this.closeIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-close') : undefined;
        this.openIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-open') : undefined;
        this.open = this.buttonEl?.getAttribute('aria-expanded') === 'true';
        this.buttonEl?.addEventListener('click', this.onButtonClick.bind(this));
        if (this.open) {
          Accordion.currentOpen = this;
        }
      }
      onButtonClick() {
        if (!this.open && Accordion.currentOpen && this.autoClose) {
          Accordion.closeCurrentOpen();
        }
        this.toggle(!this.open);
      }
      toggle(open) {
        if (open === this.open) {
          return;
        }
        this.open = open;
        Accordion.currentOpen = open ? this : null;
        this.buttonEl?.setAttribute('aria-expanded', `${open}`);
        const grandParentNode = this.buttonEl?.parentNode?.parentNode;
        this.buttonEl?.setAttribute('aria-expanded', `${open}`);
        grandParentNode?.classList.toggle('active', open);
        if (open) {
          this.autoSetHiddenAttribute ? this.contentEl?.removeAttribute('hidden') : this.contentEl?.classList.remove('hidden');
          this.closeIconEl?.classList.remove('hidden');
          this.openIconEl?.classList.add('hidden');
        } else {
          this.autoSetHiddenAttribute ? this.contentEl?.setAttribute('hidden', '') : this.contentEl?.classList.add('hidden');
          this.closeIconEl?.classList.add('hidden');
          this.openIconEl?.classList.remove('hidden');
        }
      }
      static closeCurrentOpen() {
        if (Accordion.currentOpen) {
          Accordion.currentOpen.setClose();
        }
      }
      setOpen() {
        this.toggle(true);
      }
      setClose() {
        this.toggle(false);
      }
    }

    const AccordionUtils = {
      init: () => {
        const accordionGroup = document.querySelectorAll('.accordion-group');
        accordionGroup.forEach(accordionGroupEl => {
          const autoClose = accordionGroupEl?.dataset.closeOthers === 'true';
          const autoSetHiddenAttribute = accordionGroupEl?.dataset.autoSetHiddenAttribute === 'true';
          const accordions = accordionGroupEl.querySelectorAll('.accordion');
          accordions.forEach(accordionEl => {
            new Accordion(accordionEl, autoClose, autoSetHiddenAttribute);
          });
        });
      }
    };

    const AccordionModule = () => {
      window.addEventListener('DOMContentLoaded', () => {
        AccordionUtils.init();
      });
    };

    var main = /*#__PURE__*/Object.freeze({
        __proto__: null,
        AccordionModule: AccordionModule,
        default: AccordionModule
    });

    const events$7 = window.PoleneLibs.Events.default;
    const {
      intersection: intersection$1
    } = window.PoleneLibs.Observer;
    const {
      dispatchEvent: dispatchEvent$5
    } = window.PoleneLibs.Utils;
    const PhotoSwipeLightbox = window.PoleneVendors.PhotoSwipeLightbox;
    const {
      Autoplay,
      FreeMode,
      Mousewheel,
      Navigation,
      Pagination
    } = window.PoleneVendors.SwiperModules;
    const Swiper = window.PoleneVendors.Swiper;
    const {
      getElementsByRef: getElementsByRef$9,
      getRefs: getRefs$a
    } = window.PoleneLibs.Refs;
    const {
      close
    } = window.PoleneLibs.SvgTemplates;
    const autoPlay = (swiper, {
      speed
    }) => {
      const computedDirection = document.documentElement.getAttribute('dir') === 'rtl' ? 'ltr' : 'rtl';
      const slidesAnchors = Array.from(swiper.el.querySelectorAll('a'));
      let running = true;
      let hovered = false;
      let observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const slide = entry.target;
          const index = slide.getAttribute('href');
          if (!slide || !index) return;
          if (entry.isIntersecting) {
            slide.removeAttribute('tabindex');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.setAttribute('tabindex', '-1');
            slide.setAttribute('aria-hidden', 'true');
            if (document.activeElement == slide) slide.blur();
          }
        });
      }, {
        threshold: 0.5
      });
      slidesAnchors.forEach(anchor => {
        anchor.setAttribute('tabindex', '-1');
        observer.observe(anchor);
      });
      const onPointerEnter = () => hovered = true;
      const onPointerLeave = () => hovered = false;
      const normalizedSpeed = speed ? speed / 10 : 0.5;
      swiper.el.addEventListener('pointerenter', onPointerEnter);
      swiper.el.addEventListener('focusin', onPointerEnter);
      swiper.el.addEventListener('pointerleave', onPointerLeave);
      swiper.el.addEventListener('focusout', onPointerLeave);
      swiper.on('slideChangeTransitionEnd', () => {
        const containerRect = swiper.$el[0].getBoundingClientRect();
        let lastVisibleSlide = null;
        slidesAnchors.forEach(slide => {
          const rect = slide.getBoundingClientRect();
          if (rect.left >= containerRect.left && rect.right <= containerRect.right + rect.width / 2) lastVisibleSlide = slide;
        });
        if (swiper.activeIndex > swiper.previousIndex) slidesAnchors[swiper.activeIndex].focus();else if (lastVisibleSlide && swiper.activeIndex < swiper.previousIndex) lastVisibleSlide.focus();
      });
      const tick = () => {
        if (running) requestAnimationFrame(tick);
        const dir = computedDirection !== 'rtl' ? 1 : -1;
        if (swiper.touchEventsData.isTouched || swiper.animating) return;
        if (hovered) return;
        swiper.setTransition(0);
        swiper.setTranslate(-swiper.translate * dir - normalizedSpeed);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (swiper.params.loop) {
          swiper.loopFix({
            direction: dir ? 'next' : 'prev',
            byMousewheel: true
          });
        }
      };
      tick();
      return {
        stop: () => {
          running = false;
        },
        start() {
          running = true;
          tick();
        },
        destroy: () => {
          swiper.el.removeEventListener('pointerenter', onPointerEnter);
          swiper.el.removeEventListener('focusin', onPointerEnter);
          swiper.el.removeEventListener('pointerleave', onPointerLeave);
          swiper.el.removeEventListener('focusout', onPointerLeave);
          observer.disconnect();
        }
      };
    };
    const makeVisibleSlidesFocusable = (slides, containerRect) => {
      let lastVisibleSlide = null;
      slides.forEach(slide => {
        const rect = slide.getBoundingClientRect();
        if (rect.left >= containerRect.left && rect.right <= containerRect.right + 20) {
          slide.setAttribute('tabindex', '0');
          slide.setAttribute('aria-hidden', 'false');
          lastVisibleSlide = slide;
        } else {
          slide.setAttribute('tabindex', '-1');
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      return lastVisibleSlide;
    };
    const manageFocus = swiper => {
      const slides = Array.from(swiper.slides);
      const containerRect = swiper.$el[0].getBoundingClientRect();
      const lastVisibleSlide = makeVisibleSlidesFocusable(slides, containerRect);
      if (swiper.activeIndex > swiper.previousIndex) slides[swiper.activeIndex].focus();else if (lastVisibleSlide && swiper.activeIndex < swiper.previousIndex) lastVisibleSlide.focus();
    };
    const classes$a = {
      peek: 'is-peeking'
    };
    const selectors$8 = {
      activeSlide: '.swiper-slide-active',
      nextSlide: '.swiper-slide-next'
    };
    const configurations = {
      'ticker': {
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        options: {
          autoplay: true
        },
        config: {
          centeredSlides: false,
          breakpoints: {
            320: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 20
            },
            900: {
              slidesPerView: 7,
              slidesPerGroup: 7,
              spaceBetween: 30
            }
          },
          freeMode: {
            enabled: false,
            sticky: false,
            momentumRatio: 0.1,
            momentumVelocityRatio: 0.1
          },
          navigation: {
            nextEl: '.carousel__button-next',
            prevEl: '.carousel__button-prev'
          }
        }
      },
      'triple': {
        options: {},
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          spaceBetween: 12,
          slidesPerView: 2,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          }
        }
      },
      'article-list': {
        options: {},
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          spaceBetween: 12,
          slidesPerView: 3,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          }
        }
      },
      'product-hero': {
        options: {},
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          spaceBetween: 0,
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          }
        }
      },
      'image-carousel': {
        options: {
          hasNextClick: true
        },
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          centeredSlides: false,
          loop: false
        }
      },
      'variant-selector': {
        options: {
          hasNextClick: false
        },
        config: {
          spaceBetween: 4,
          breakpoints: {
            600: {
              slidesPerView: 'auto',
              slidesPerGroup: 'auto'
            },
            1024: {
              slidesPerView: 6,
              slidesPerGroup: 6
            }
          },
          loop: false,
          centeredSlides: false,
          navigation: {
            nextEl: '.carousel__button-next',
            prevEl: '.carousel__button-prev'
          },
          on: {
            init: function (swiper) {
              swiper.initialized = false;
              const activeSlide = swiper.el.querySelector('.is-active');
              if (activeSlide) {
                const activeIndex = Array.from(swiper.slides).indexOf(activeSlide);
                if (activeIndex >= 6) {
                  swiper.slideTo(activeIndex, 0);
                }
                requestAnimationFrame(() => {
                  makeVisibleSlidesFocusable(Array.from(swiper.slides), swiper.$el[0].getBoundingClientRect());
                  setTimeout(() => {
                    swiper.initialized = true;
                  }, 100);
                });
              } else {
                swiper.initialized = true;
              }
            },
            slideChangeTransitionEnd: swiper => {
              if (swiper.initialized) {
                manageFocus(swiper);
              }
            }
          }
        }
      }
    };
    var componentCarousel = () => {
      const {
        carousel
      } = getElementsByRef$9('carousel');
      if (!carousel) {
        return;
      }
      if (!carousel) return;
      const carousels = Array.isArray(carousel) ? [...carousel] : [carousel];
      const swipers = carousels.map(carousel => {
        let swiper;
        let hasPeeked = false;
        let convention;
        let autoPlayer;
        let observer;
        const initSwiper = ({
          container,
          config,
          options,
          autoplaySpeed
        }) => {
          swiper = new Swiper(container, config);
          if (options.autoplay) autoPlayer = autoPlay(swiper, {
            speed: autoplaySpeed
          });
          if (swiper.slides.length > 2 && !!options.hasNextClick) {
            swiper.slides.forEach(slide => {
              slide.addEventListener('mouseenter', handleMouseEnter);
            });
          }
        };
        const handleMouseEnter = e => {
          if (!swiper) return;
          const next = e.target.closest(selectors$8.nextSlide);
          const active = e.target.closest(selectors$8.activeSlide);
          const isFirstItem = swiper.activeIndex === 0;
          const isLastItem = swiper.activeIndex === swiper.slides.length - 2;
          if (next && !isLastItem) {
            dispatchEvent$5(window, events$7.CHANGE_CURSOR, {
              type: 'next',
              contrast: true
            });
          } else if (active && !isFirstItem) {
            dispatchEvent$5(window, events$7.CHANGE_CURSOR, {
              type: 'prev',
              contrast: true
            });
          } else {
            dispatchEvent$5(window, events$7.CHANGE_CURSOR, {
              type: 'default',
              contrast: false
            });
          }
        };
        const handleNextClick = e => {
          if (!swiper) return;
          const next = e.target.closest(selectors$8.nextSlide);
          const active = e.target.closest(selectors$8.activeSlide);
          const firstItemClicked = swiper.clickedIndex === 0;
          const lastItemClicked = swiper.clickedIndex === swiper.slides.length - 1;
          if (next && !lastItemClicked) {
            swiper.slideNext();
          }
          if (active && !firstItemClicked) {
            swiper.slidePrev();
          }
        };
        const handleIntersection = ([entry]) => {
          if (!swiper) return;
          const peekIndex = swiper.activeIndex + 2;
          if (peekIndex > 3) return;
          const peekItem = swiper.slides[peekIndex];
          if (entry.isIntersecting && !hasPeeked) {
            peekItem.classList.add(classes$a.peek);
            hasPeeked = true;
          }
        };
        const resetCursor = () => {
          dispatchEvent$5(window, events$7.CHANGE_CURSOR, {
            type: 'default',
            contrast: false
          });
        };
        const removeAllEventListeners = () => {
          if (autoPlayer) autoPlayer.destroy();
          if (carousel) {
            carousel.removeEventListener('click', handleNextClick);
            carousel.removeEventListener('mouseleave', resetCursor);
          }
          if (swiper) swiper.slides.forEach(slide => {
            slide.removeEventListener('mouseenter', handleMouseEnter);
          });
          if (observer) observer.disconnect();
        };
        const {
          configType,
          configHorizontalScroll,
          configAutoplay,
          configAutoplaySpeed,
          configPagination
        } = carousel.dataset;
        if (!configType) return removeAllEventListeners;
        const options = configurations[configType].options;
        const {
          container
        } = getRefs$a(carousel);
        if (configAutoplay) {
          configurations[configType].options.autoplay = configAutoplay === 'true';
        }
        if (configPagination && configPagination === 'true') {
          configurations[configType].config.pagination = {
            el: '.swiper-pagination',
            type: 'bullets'
          };
        }
        convention = {
          modules: [Mousewheel, FreeMode, Autoplay, Pagination, Navigation],
          freeMode: {
            enabled: true,
            sticky: false
          },
          pagination: false,
          slidesPerView: 'auto',
          direction: 'horizontal',
          watchOverflow: true,
          loop: true,
          centeredSlides: true,
          allowTouchMove: configHorizontalScroll ? configHorizontalScroll === 'true' : true,
          mousewheel: {
            invert: false,
            forceToAxis: true,
            enabled: configHorizontalScroll ? configHorizontalScroll === 'true' : true
          },
          ...configurations[configType].config
        };
        initSwiper({
          container: container,
          config: convention,
          options: options,
          autoplaySpeed: parseFloat(configAutoplaySpeed ? configAutoplaySpeed : '0.5')
        });
        if (configType === 'product-hero') {
          if (!swiper?.slides.length) return removeAllEventListeners;
          const lightbox = new PhotoSwipeLightbox({
            closeSVG: close,
            bgOpacity: 1,
            gallery: carousel,
            children: swiper.slides,
            zoom: false,
            counter: false,
            initialZoomLevel: 'fill',
            secondaryZoomLevel: 1,
            maxZoomLevel: 2,
            pswpModule: window.PoleneVendors.PhotoSwipe
          });
          lightbox.init();
        }
        if (options.hasNextClick) {
          carousel.addEventListener('click', handleNextClick);
          carousel.addEventListener('mouseleave', resetCursor);
          if (!swiper || 'imagesToLoad' in swiper && Array.isArray(swiper.imagesToLoad) && swiper.imagesToLoad.length <= 2) return removeAllEventListeners;
          observer = intersection$1(carousel, handleIntersection, {
            threshold: [0.8]
          });
        }
        return removeAllEventListeners;
      });
      return () => {
        swipers.forEach(teardown => teardown());
      };
    };

    var componentCarousel$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentCarousel
    });

    const {
      isMobile: isMobile$3
    } = window.PoleneLibs.Utils;
    class ComponentModal extends HTMLElement {
      static FOCUS_DELAY = 100;
      controller = undefined;
      backdrop = null;
      closeButton = null;
      focusableElements = null;
      extOpenTrigger = null;
      extCloseTrigger = null;
      previousActiveElement = null;
      focusTimeout = null;
      fsModalClassInitiallyPresent = false;
      triggerScope = 'parent';
      isOpen = false;
      hideMessengerPopup = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.triggerScope = this.dataset.triggerScope || 'parent';
        this.initializeElements();
        this.applyAccessibility();
      }
      updatedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.triggerScope = this.dataset.triggerScope || 'parent';
        this.isOpen = false;
        if (this.focusTimeout) {
          clearTimeout(this.focusTimeout);
          this.focusTimeout = null;
        }
        this.initializeElements();
        this.applyAccessibility();
      }
      disconnectedCallback() {
        document.body.style.overflow = '';
        this.controller?.abort();
      }
      initializeElements = () => {
        const {
          openSelector,
          closeSelector,
          hideMessengerPopup
        } = this.dataset;
        this.hideMessengerPopup = hideMessengerPopup === 'true';
        if (this.nextElementSibling?.matches('.component-modal__backdrop')) {
          const backdrop = this.nextElementSibling;
          if (backdrop) this.backdrop = backdrop;
        }
        this.closeButton = this.querySelector('.component-modal__close');
        const root = this.triggerScope === 'parent' ? this.parentElement : document;
        if (root) {
          if (!!openSelector) this.extOpenTrigger = root.querySelectorAll(openSelector);
          if (!!closeSelector) this.extCloseTrigger = root.querySelectorAll(closeSelector);
        }
        this.initFocusableElements();
        this.setupEventListeners();
      };
      setupEventListeners = () => {
        this.extOpenTrigger?.forEach(trigger => {
          trigger.addEventListener('click', this.open, {
            signal: this.controller?.signal
          });
        });
        this.extCloseTrigger?.forEach(trigger => {
          trigger.addEventListener('click', this.close, {
            signal: this.controller?.signal
          });
        });
        this.closeButton?.addEventListener('click', this.close, {
          signal: this.controller?.signal
        });
        this.addEventListener('click', this.handleOverlayClick, {
          signal: this.controller?.signal
        });
        if (this.backdrop) {
          this.backdrop.addEventListener('click', this.close, {
            signal: this.controller?.signal
          });
        }
      };
      applyAccessibility = () => {
        this.removeEventListener('keydown', this.handleKeyDown);
        this.addEventListener('keydown', this.handleKeyDown, {
          signal: this.controller?.signal
        });
      };
      handleOverlayClick = e => {
        if (e.target === this) this.close();
      };
      handleKeyDown = e => {
        switch (e.key) {
          case 'Escape':
            this.close();
            break;
          case 'Tab':
            this.manageFocus(e);
            break;
        }
      };
      initFocusableElements = () => {
        this.focusableElements = Array.from(this.querySelectorAll(FOCUSABLE_SELECTORS));
      };
      manageFocus = e => {
        const elements = this.focusableElements;
        if (!elements?.length) return;
        const firstElement = elements[0];
        const lastElement = elements[elements.length - 1];
        const isTabbing = !e.shiftKey;
        const isReverseTabbing = e.shiftKey;
        const isLastElement = document.activeElement.dataset.isLastFocus === 'true';
        if (isTabbing && isLastElement) {
          this.closeButton?.focus();
          e.preventDefault();
        } else if (isReverseTabbing && document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        } else if (isTabbing && document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      };
      open = () => {
        if (this.isOpen === true) return;
        if (document.body.classList.contains('fullscreen-active')) this.fsModalClassInitiallyPresent = true;
        if (this.dataset.fullscreen === 'true') document.body.classList.add('fullscreen-active');
        this.classList.add('active');
        this.ariaHidden = 'false';
        document.body.style.overflow = 'hidden';
        this.previousActiveElement = document.activeElement ?? null;
        this.initFocusableElements();
        this.focusTimeout = setTimeout(() => {
          if (this.focusableElements) this.focusableElements[0].focus();
          this.focusTimeout = null;
        }, ComponentModal.FOCUS_DELAY);
        this.isOpen = true;
        if (isMobile$3() || this.hideMessengerPopup) {
          window?.zE?.('messenger', 'hide');
        }
        document.dispatchEvent(new CustomEvent('modal', {
          detail: {
            action: 'open',
            type: this.dataset.type || null
          }
        }));
      };
      close = () => {
        this.classList.remove('active');
        this.classList.add('closing');
        setTimeout(() => {
          if (this.isOpen === false) return;
          if (this.dataset.fullscreen === 'true' && !this.fsModalClassInitiallyPresent) document.body.classList.remove('fullscreen-active');
          this.classList.remove('closing');
          this.ariaHidden = 'true';
          document.body.style.overflow = '';
          this.previousActiveElement?.focus();
          if (this.focusTimeout) clearTimeout(this.focusTimeout);
          this.isOpen = false;
        }, ComponentModal.FOCUS_DELAY);
        if (isMobile$3() || this.hideMessengerPopup) {
          window?.zE?.('messenger', 'show');
        }
        document.dispatchEvent(new CustomEvent('modal', {
          detail: {
            action: 'close',
            type: this.dataset.type || null
          }
        }));
      };
      static define() {
        if (!customElements.get('component-modal')) {
          customElements.define('component-modal', ComponentModal);
        }
      }
    }
    var componentModal = () => {
      ComponentModal.define();
    };

    var componentModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentModal: ComponentModal,
        default: componentModal
    });

    const {
      getElementsByRef: getElementsByRef$8
    } = window.PoleneLibs.Refs;
    class ComponentTabs extends HTMLElement {
      tabs = [];
      panels = [];
      activePanel = undefined;
      activeTab = undefined;
      isLastInFocusTrap = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          tab,
          tabPanel
        } = getElementsByRef$8(['tab', 'tab-panel'], this);
        if (!tab || !tabPanel) return;
        this.tabs = Array.isArray(tab) ? tab : [tab];
        this.panels = Array.isArray(tabPanel) ? tabPanel : [tabPanel];
        this.activeTab = this.tabs.find(trigger => trigger?.classList.contains('active'));
        this.activePanel = this.panels.find(panel => panel?.classList.contains('active') && this.activeTab?.dataset.panelId === panel.id);
        this.isLastInFocusTrap = this.dataset.isLastInFocusTrap === 'true';
      };
      setupEventListeners = () => {
        this.tabs.forEach(tab => tab?.addEventListener('click', this.handleClick));
      };
      removeEventListeners = () => {
        this.tabs.forEach(tab => tab?.removeEventListener('click', this.handleClick));
      };
      setupAccessibility = () => {
        this.panels.forEach(panel => {
          if (panel) {
            panel.tabIndex = panel.classList.contains('active') ? 0 : -1;
          }
        });
        if (this.isLastInFocusTrap) {
          this.panels.forEach(panel => {
            if (panel && panel.lastElementChild) panel.lastElementChild.setAttribute('data-is-last-focus', 'true');
          });
        }
      };
      handleClick = event => {
        const triggeredTab = event.currentTarget;
        const {
          panelId
        } = triggeredTab.dataset;
        if (triggeredTab === this.activeTab) return;
        this.switchTab(triggeredTab);
        if (panelId) this.switchPanel(panelId);
      };
      switchTab = targetTab => {
        if (this.activeTab) {
          this.activeTab.classList.remove('active');
          this.activeTab.ariaSelected = 'false';
        }
        if (!targetTab.classList.contains('active')) {
          targetTab.classList.add('active');
          targetTab.ariaSelected = 'true';
        }
        this.activeTab = targetTab;
      };
      switchPanel = targetPanelId => {
        const newActivePanel = this.panels.find(panel => targetPanelId === panel?.id);
        if (this.activePanel) {
          this.activePanel.classList.remove('active');
          this.activePanel.ariaHidden = 'true';
          this.activePanel.tabIndex = -1;
        }
        if (newActivePanel && !newActivePanel.classList.contains('active')) {
          newActivePanel.classList.add('active');
          newActivePanel.ariaHidden = 'false';
          newActivePanel.tabIndex = 0;
          this.activePanel = newActivePanel;
        }
      };
      static define = () => {
        if (!customElements.get('component-tabs')) {
          customElements.define('component-tabs', ComponentTabs);
        }
      };
    }
    var componentTabs = () => {
      ComponentTabs.define();
    };

    var componentTabs$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentTabs: ComponentTabs,
        default: componentTabs
    });

    const {
      getElementByRef: getElementByRef$g
    } = window.PoleneLibs.Refs;
    class ComponentProductCard extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {}
      init() {
        this.handleImgLoad();
      }
      handleImgLoad = () => {
        const {
          productCardImg
        } = getElementByRef$g('product-card-img', this);
        if (!productCardImg) return;
        const {
          imgSrc
        } = productCardImg.dataset;
        const pImg = new Image();
        if (imgSrc) {
          pImg.src = imgSrc;
          pImg.addEventListener('load', () => {
            if (productCardImg?.parentNode instanceof HTMLElement) {
              productCardImg.parentNode.classList.add('is-visible');
            }
          });
        }
      };
      static define() {
        if (!customElements.get('component-product-card')) {
          customElements.define('component-product-card', ComponentProductCard);
        }
      }
    }
    var componentProductCard = () => {
      ComponentProductCard.define();
    };

    var componentProductCard$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductCard
    });

    const {
      wrappedLoader
    } = window.PoleneLibs.ElementTemplates;
    const events$6 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$4,
      parseProductForm
    } = window.PoleneLibs.Utils;
    const {
      getRefs: getRefs$9
    } = window.PoleneLibs.Refs;
    const {
      morphSection
    } = window.PoleneLibs.SectionRenderer;
    const root = window.Shopify?.routes.root;
    const selectors$7 = {
      cartCounter: '.js-cart-counter',
      variantInput: '.js-variant-input'
    };
    const added_to_cart$1 = window.translations?.added_to_cart || 'Added to cart';
    const fetchCart = async () => {
      try {
        const response = await fetch(root + 'cart.js', {
          method: 'GET'
        });
        const cart = await response.json();
        fetchHandler(cart);
      } catch (error) {}
    };
    const updateCartContent = async section => {
      try {
        const cartComponent = document.querySelector('component-cart-items');
        const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
        await morphSection(sectionId, section);
        dispatchEvent$4(window, events$6.CART_UPDATED);
        dispatchEvent$4(window, events$6.CART_DOM_UPDATED);
      } catch (error) {
        const {
          cart
        } = getRefs$9();
        if (cart) {
          cart.innerHTML = section;
          setCartCount(0);
        }
      }
    };
    const fetchHandler = cart => {
      updateCartCount(cart);
    };
    const updateCartCount = cart => {
      setTimeout(() => {
        setCartCount(cart.item_count);
      });
    };
    const setCartCount = amount => {
      const counters = document.querySelectorAll(selectors$7.cartCounter);
      counters.forEach(counter => {
        const currentText = counter.innerHTML;
        const newText = counter.classList.contains('visually-hidden') ? currentText.replace(/\d+/, amount.toString()) : amount.toString();
        counter.innerHTML = newText;
      });
    };
    const triggeredProductForm = {};
    const handleAddToCart = async productForm => {
      const forms = productForm.getElementsByTagName('form');
      const form = forms[0];
      const formData = new FormData(form);
      const items = parseProductForm(formData);
      const btns = form.getElementsByTagName('button');
      const inputs = form.getElementsByTagName('input');
      const submitBtn = btns[0];
      const defaultSubmitBtnState = submitBtn.dataset.defaultState;
      let preOrderBtn = false;
      let preOrderLabel = '';
      let eContainer;
      const states = {
        success: 'success',
        loading: 'loading',
        default: 'default',
        disabled: 'disabled'
      };
      if (submitBtn.dataset.state == states.disabled) {
        let variantId = null;
        if (!items.length) {
          variantId = form.querySelectorAll(selectors$7.variantInput)[0].value;
        } else {
          variantId = items[0].id;
          const hasOptions = form.getElementsByTagName('option');
          if (hasOptions && items[0].id === '0') {
            variantId = form.getElementsByTagName('option')[1].value;
          }
        }
        dispatchEvent$4(window, events$6.TOGGLE_BIS, {
          variantId
        });
        return;
      }
      if (productForm.nextElementSibling) {
        const {
          errorContainer
        } = getRefs$9(productForm.nextElementSibling);
        eContainer = errorContainer;
      }
      if (!submitBtn.firstElementChild) {
        preOrderBtn = true;
        preOrderLabel = submitBtn.innerHTML;
        submitBtn.innerHTML = wrappedLoader;
      }
      submitBtn.dataset.state = states.loading;
      const cartComponent = document.querySelector('component-cart-items');
      const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items,
            sections: `${sectionId},cart-notification-product`
          })
        });
        const json = await response.json();
        if (response.ok) {
          if (cartComponent && json.sections && json.sections[sectionId]) {
            await updateCartContent(json.sections[sectionId]);
          }
          dispatchEvent$4(window, events$6.CART_UPDATED, json);
          submitBtn.dataset.state = states.success;
          if (eContainer && eContainer.innerHTML) eContainer.innerHTML = '';
          if (preOrderBtn) submitBtn.innerHTML = added_to_cart$1;
          if (productForm.dataset.handle in triggeredProductForm) {
            clearTimeout(triggeredProductForm[productForm.dataset.handle]);
            delete triggeredProductForm[productForm.dataset.handle];
          }
          triggeredProductForm[productForm.dataset.handle] = setTimeout(() => {
            submitBtn.dataset.state = defaultSubmitBtnState;
            [...inputs].forEach(input => {
              input.checked = false;
            });
            if (preOrderBtn) {
              submitBtn.innerHTML = preOrderLabel;
            }
            clearTimeout(triggeredProductForm[productForm.dataset.handle]);
            delete triggeredProductForm[productForm.dataset.handle];
          }, 3000);
        } else {
          submitBtn.dataset.state = defaultSubmitBtnState;
          if (eContainer) {
            eContainer.innerHTML = json.description;
            setTimeout(() => {
              eContainer.innerHTML = '';
            }, 5000);
          }
        }
      } catch (error) {
        submitBtn.dataset.state = defaultSubmitBtnState;
      }
    };

    const {
      getElementByRef: getElementByRef$f
    } = window.PoleneLibs.Refs;
    const events$5 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$3,
      isMobile: isMobile$2
    } = window.PoleneLibs.Utils;
    const VS_TRANSITION_DURATION = 1000;
    const selectors$6 = {
      sizeSelector: '.js-size-selector',
      productForm: '.js-product-form',
      productAnchor: '.js-product-anchor',
      addToCart: '.js-add-to-cart',
      faveBtn: '.js-fave-btn'
    };
    const classes$9 = {
      preorderInput: 'preorder-note',
      mobile: 'is-mobile',
      preorderOverlay: 'is-preorder-overlay'
    };
    class ComponentProductForm extends HTMLElement {
      productForm = this.getElementsByTagName('form')[0];
      refs = getElementByRef$f('variant-selector', this);
      isVariantSelectorHovered = false;
      isProcessingAddToCart = false;
      resetTimeout = 0;
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        if (this.productForm) {
          this.productForm.removeEventListener('input', this.handleFormChange);
        }
        this.removeEventListener('click', this.handleClick);
        if (this.refs.variantSelector) {
          this.refs.variantSelector.removeEventListener('mouseenter', this.handleVSelectorMouseenter);
          this.refs.variantSelector.removeEventListener('mouseleave', this.handleVSelectorMouseleave);
        }
      }
      init() {
        if (this.productForm) {
          this.productForm.addEventListener('input', this.handleFormChange);
        }
        if (!this.classList.contains('is-mini')) {
          this.addEventListener('click', this.handleClick);
        }
        if (this.refs.variantSelector) {
          this.refs.variantSelector.addEventListener('mouseenter', this.handleVSelectorMouseenter);
          this.refs.variantSelector.addEventListener('mouseleave', this.handleVSelectorMouseleave);
        }
      }
      handleVSelectorMouseenter = () => {
        if (isMobile$2()) return;
        if (this.refs.variantSelector && this.isVariantSelectorHovered === false) {
          this.isVariantSelectorHovered = true;
          this.refs.variantSelector.disabled = true;
          this.timeoutId = setTimeout(() => {
            if (this.isVariantSelectorHovered === true) this.refs.variantSelector.disabled = false;
            if (this.timeoutId) {
              clearTimeout(this.timeoutId);
              this.timeoutId = 0;
            }
          }, VS_TRANSITION_DURATION);
        }
      };
      handleVSelectorMouseleave = () => {
        if (isMobile$2()) return;
        if (this.refs.variantSelector && this.isVariantSelectorHovered === true) {
          this.isVariantSelectorHovered = false;
          this.refs.variantSelector.disabled = true;
        }
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
          this.timeoutId = 0;
        }
      };
      handleFormChange = event => {
        event.preventDefault();
        if (!(event.target instanceof HTMLInputElement)) return;
        if (this.isProcessingAddToCart) return;
        if (event.target.dataset.availability == 'false') {
          dispatchEvent$3(window, events$5.TOGGLE_BIS, {
            variantId: event.target.value
          });
          return;
        } else {
          const productForm = event.target.closest(selectors$6.productForm);
          if (productForm) {
            this.isProcessingAddToCart = true;
            handleAddToCart(productForm);
            setTimeout(() => {
              this.isProcessingAddToCart = false;
            }, 1000);
          }
        }
      };
      handleClick = event => {
        if (!event.target || !(event.target instanceof Element) || !(event.currentTarget instanceof Element)) {
          return;
        }
        const productForm = event.target.closest(selectors$6.productForm);
        const sizeSelector = event.target.closest(selectors$6.sizeSelector);
        const faveBtn = event.target.closest(selectors$6.faveBtn);
        const productAnchor = event.currentTarget.querySelector(selectors$6.productAnchor);
        if (faveBtn || sizeSelector) return;
        if (productForm) {
          event.preventDefault();
          if (this.isProcessingAddToCart) return;
          const btns = productForm.getElementsByTagName('button');
          const submitBtn = btns[0];
          const preOrderInput = productForm.getElementsByClassName(classes$9.preorderInput);
          if (this.classList.contains('quick-buy-form') && productForm.querySelector(selectors$6.sizeSelector) && isMobile$2()) {
            this.updateCartNotification(productForm, classes$9.mobile, 'variantSelector');
            return;
          }
          if (preOrderInput.length && isMobile$2()) {
            this.updateCartNotification(productForm, classes$9.preorderOverlay, 'preorder');
            return;
          }
          if (submitBtn.dataset.state === 'inactive') {
            return;
          }
          this.isProcessingAddToCart = true;
          handleAddToCart(productForm);
          setTimeout(() => {
            this.isProcessingAddToCart = false;
          }, 1000);
          return;
        }
        if (productAnchor) {
          const url = productAnchor.getAttribute('href');
          if (url) {
            window.location.href = url;
          }
        }
      };
      updateCartNotification = (form, className, state) => {
        if (this.isProcessingAddToCart) {
          clearTimeout(this.resetTimeout);
        }
        this.isProcessingAddToCart = true;
        const clone = form.cloneNode(true);
        const obj = {
          element: clone,
          className,
          state,
          handle: form.dataset.handle
        };
        dispatchEvent$3(window, events$5.TRIGGER_NOTIFICATION_LAYOUT, obj);
        this.resetTimeout = Number(setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 500));
      };
      static define() {
        if (!customElements.get('component-product-form')) {
          customElements.define('component-product-form', ComponentProductForm);
        }
      }
    }
    var componentProductForm = () => {
      ComponentProductForm.define();
    };

    var componentProductForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductForm
    });

    class ComponentDrawer extends HTMLElement {
      previousActiveElement = null;
      constructor() {
        super();
        this.elements = {
          closeButton: null,
          focusableElements: null
        };
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        this.elements.closeButton = this.querySelector('[data-ref="drawer-close-btn"]');
        this.elements.focusableElements = Array.from(this.querySelectorAll(FOCUSABLE_SELECTORS));
      };
      setupEventListeners = () => {
        this.addEventListener('keydown', this.handleKeyDown);
        this.addEventListener('click', this.handleClick);
        this.elements.closeButton?.addEventListener('click', this.close);
      };
      removeEventListeners = () => {
        this.removeEventListener('keydown', this.handleKeyDown);
        this.removeEventListener('click', this.handleClick);
        this.elements.closeButton?.removeEventListener('click', this.close);
      };
      handleClick = e => {
        if (e.target === this) this.close();
      };
      handleKeyDown = e => {
        switch (e.key) {
          case 'Escape':
            this.close();
            break;
          case 'Tab':
            this.manageFocus(e);
            break;
          case 'Enter':
            this.manageEnter(e);
            break;
        }
      };
      manageEnter = e => {
        e.preventDefault();
        e.target?.dispatchEvent(new PointerEvent('click'));
      };
      manageFocus = e => {
        const elements = this.elements.focusableElements;
        if (!elements?.length) return;
        const firstElement = elements[0];
        const lastElement = elements[elements.length - 1];
        const isTabbing = !e.shiftKey;
        const isReverseTabbing = e.shiftKey;
        if (isReverseTabbing && document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        } else if (isTabbing && document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      };
      open = () => {
        this.previousActiveElement = document.activeElement ?? null;
        document.body.classList.add('drawer-open');
        this.classList.add('active');
        this.ariaHidden = 'false';
        this.ariaExpanded = 'true';
        setTimeout(() => {
          if (this.elements.focusableElements) this.elements.focusableElements[0].focus();
        }, 100);
        document.body.style.overflow = 'hidden';
      };
      close = () => {
        document.body.classList.remove('drawer-open');
        this.classList.remove('active');
        this.ariaHidden = 'true';
        this.ariaExpanded = 'false';
        this.previousActiveElement?.focus();
        document.body.style.overflow = 'visible';
        window?.zE?.('messenger', 'show');
      };
      static define = () => {
        if (!customElements.get('component-drawer')) {
          customElements.define('component-drawer', ComponentDrawer);
        }
      };
    }
    var componentDrawer = () => {
      ComponentDrawer.define();
    };

    var componentDrawer$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentDrawer: ComponentDrawer,
        default: componentDrawer
    });

    const {
      getElementsByRef: getElementsByRef$7,
      getElementByRef: getElementByRef$e
    } = window.PoleneLibs.Refs;
    const {
      mod,
      isFocusable,
      addScrollEndListener
    } = window.PoleneLibs.Utils;
    const {
      ACTIVE_SLIDE_CHANGE
    } = window.PoleneLibs.Events.default;
    const DRAG_TOLERANCE = 5;
    const SLIDES_QTY_MARGIN = 2;
    const INIT_SCROLL_DELAY = 100;
    const SCROLL_MIN_DISTANCE = !IS_WEBKIT && window.devicePixelRatio >= 2 ? 0.5 : 1;
    class ComponentSlider extends HTMLElement {
      controller = undefined;
      intersectionObservers = {
        slider: undefined,
        slides: undefined
      };
      mutationObservers = {
        slider: undefined
      };
      slider = undefined;
      slides = [];
      visibleSlides = [];
      lastSlide = undefined;
      firstSlide = undefined;
      lastVisibleSlide = undefined;
      activeIndex = undefined;
      isVisible = false;
      showDots = false;
      slideFullPage = false;
      slidesPerView = undefined;
      slidesPerViewMobile = undefined;
      slidesToScroll = 1;
      loop = false;
      gap = 0;
      initialSlideIndex = undefined;
      autoplay = false;
      autoplaySpeed = 20;
      autoplayDirection = 1;
      centered = false;
      lockSwipeOnScroll = false;
      ownerEl = null;
      customNextBtns = [];
      customPrevBtns = [];
      nextBtn = undefined;
      prevBtn = undefined;
      dotsContainer = undefined;
      dots = [];
      activeDot = null;
      dragStartX = 0;
      dragCurrentX = 0;
      dragTimeout = null;
      touchStartX = 0;
      touchStartY = 0;
      lastTouchY = 0;
      touchIntent = 'none';
      swipeLocked = false;
      touchId = null;
      isMouseDown = false;
      isDragging = false;
      isHovered = false;
      isFocused = false;
      isScrolling = false;
      isTouching = false;
      secondsPassed = 0;
      oldTimeStamp = 0;
      isFirstFrame = true;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.parseDatasetParams();
        this.initializeElements();
        this.setupEventListeners();
        this.setupObservers();
        this.handleInitialSlide();
        if (this.autoplay && this.loop) requestAnimationFrame(this.play);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.removeObservers();
      }
      initializeElements = () => {
        try {
          const {
            sliderSlide,
            sliderDot
          } = getElementsByRef$7(['slider-slide', 'slider-dot'], this);
          const {
            sliderSlidesContainer,
            sliderPrev,
            sliderNext,
            sliderDotsContainer
          } = getElementByRef$e(['slider-slides-container', 'slider-prev', 'slider-next', 'slider-dots-container'], this);
          this.slides = (sliderSlidesContainer ? Array.isArray(sliderSlide) ? sliderSlide : [sliderSlide] : []).filter(slide => slide != undefined);
          this.slider = sliderSlidesContainer;
          if (this.validateRequirements() === false) throw 'ComponentSlider minimum requirements are not respected.';
          if (this.centered && this.slider) {
            this.slider.style.touchAction = 'pan-y';
            this.slider.classList.add('centered');
          }
          this.duplicateSlides();
          this.dots = sliderDot ? Array.isArray(sliderDot) ? sliderDot : [sliderDot] : [];
          this.dotsContainer = sliderDotsContainer;
          this.nextBtn = sliderNext;
          this.prevBtn = sliderPrev;
          if (this.slides.length > 0) {
            this.firstSlide = this.slides[0];
            this.lastSlide = this.slides[this.slides.length - 1];
            this.initializeIndexes();
          }
        } catch (error) {}
      };
      parseDatasetParams = () => {
        const {
          slideFullPage,
          loop,
          gap,
          showDots,
          initialSlide,
          ownerSelector,
          slidesPerView,
          slidesPerViewMobile,
          slidesToScroll,
          autoplay,
          autoplaySpeed,
          autoplayDirection,
          centered,
          lockSwipeOnScroll,
          customNextBtnsSelector,
          customPrevBtnsSelector
        } = this.dataset;
        this.slideFullPage = slideFullPage === 'true';
        this.loop = loop === 'true';
        this.gap = gap ? +gap : this.gap;
        this.showDots = showDots === 'true';
        this.initialSlideIndex = !!initialSlide ? +initialSlide : undefined;
        this.ownerEl = !!ownerSelector ? this.closest(ownerSelector) : null;
        this.slidesPerView = !!slidesPerView ? +slidesPerView : undefined;
        this.slidesPerViewMobile = !!slidesPerViewMobile ? +slidesPerViewMobile : undefined;
        this.slidesToScroll = !!slidesToScroll ? +slidesToScroll : this.slidesToScroll;
        this.autoplay = autoplay === 'true';
        this.autoplaySpeed = !!autoplaySpeed ? +autoplaySpeed : this.autoplaySpeed;
        this.autoplayDirection = !!autoplayDirection ? +autoplayDirection : this.autoplayDirection;
        this.centered = centered === 'true';
        this.lockSwipeOnScroll = lockSwipeOnScroll === 'true';
        if (this.ownerEl) {
          this.customNextBtns = !!customNextBtnsSelector ? Array.from(this.ownerEl.querySelectorAll(customNextBtnsSelector)) : [];
          this.customPrevBtns = !!customPrevBtnsSelector ? Array.from(this.ownerEl.querySelectorAll(customPrevBtnsSelector)) : [];
        }
      };
      validateRequirements() {
        try {
          if (!this.slider) {
            return false;
          }
          return true;
        } catch (error) {
          return false;
        }
      }
      setupEventListeners = () => {
        this.nextBtn?.addEventListener('click', this.handleNext, {
          signal: this.controller?.signal
        });
        this.prevBtn?.addEventListener('click', this.handlePrev, {
          signal: this.controller?.signal
        });
        this.customPrevBtns.forEach(btn => btn.addEventListener('click', this.handlePrev, {
          signal: this.controller?.signal
        }));
        this.customNextBtns.forEach(btn => btn.addEventListener('click', this.handleNext, {
          signal: this.controller?.signal
        }));
        this.slider?.addEventListener('mousedown', this.handleMousedown, {
          signal: this.controller?.signal
        });
        this.slider?.addEventListener('scroll', this.handleScroll, {
          signal: this.controller?.signal
        });
        this.slider?.addEventListener('scrollend', this.handleScrollEnd, {
          signal: this.controller?.signal
        });
        this.addEventListener('mouseenter', this.handleMouseEnter, {
          signal: this.controller?.signal
        });
        this.addEventListener('mouseleave', this.handleMouseLeave, {
          signal: this.controller?.signal
        });
        this.addEventListener('focusin', this.handleFocusIn, {
          signal: this.controller?.signal
        });
        this.addEventListener('focusout', this.handleFocusOut, {
          signal: this.controller?.signal
        });
        this.addEventListener('wheel', this.handleWheel, {
          signal: this.controller?.signal
        });
        this.slider?.addEventListener('touchstart', this.handleTouchStart, {
          signal: this.controller?.signal,
          passive: true
        });
        this.slider?.addEventListener('touchmove', this.handleTouchMove, {
          signal: this.controller?.signal,
          passive: false
        });
        this.slider?.addEventListener('touchend', this.handleTouchEnd, {
          signal: this.controller?.signal,
          passive: true
        });
        this.slider?.addEventListener('touchcancel', this.handleTouchCancel, {
          signal: this.controller?.signal,
          passive: true
        });
        if (this.loop) this.addEventListener('keydown', this.handleKeydown, {
          signal: this.controller?.signal
        });
      };
      setupObservers = () => {
        this.setupSliderObserver();
        this.setupSlidesObserver();
      };
      setupSliderObserver = () => {
        try {
          if (!this.slider) return;
          this.intersectionObservers.slider = new IntersectionObserver(entries => entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible === true) requestAnimationFrame(this.play);
          }));
          this.mutationObservers.slider = new MutationObserver(() => this.resetSlider());
          this.intersectionObservers.slider?.observe(this.slider);
          this.mutationObservers.slider?.observe(this.slider, {
            subtree: true,
            childList: true
          });
        } catch (error) {}
      };
      setupSlidesObserver = () => {
        try {
          if (!this.slider || !this.slides.length) return;
          const observerOptions = {
            root: this.slider,
            threshold: this.centered ? 0.5 : this.loop || this.slidesPerView === 1 || this.slidesPerViewMobile === 1 ? 1 : 0.8
          };
          this.intersectionObservers.slides = new IntersectionObserver(this.handleSlideVisibilityChange, observerOptions);
          this.slides.forEach(slide => {
            if (!slide) return;
            this.intersectionObservers.slides?.observe(slide);
          });
        } catch (error) {}
      };
      removeObservers = () => {
        for (const key in this.intersectionObservers) {
          if (this.intersectionObservers[key]) {
            this.intersectionObservers[key].disconnect();
            this.intersectionObservers[key] = undefined;
          }
        }
        for (const key in this.mutationObservers) {
          if (this.mutationObservers[key]) {
            this.mutationObservers[key].disconnect();
            this.mutationObservers[key] = undefined;
          }
        }
      };
      resetSlider = () => {
        this.controller?.abort();
        this.controller = new AbortController();
        this.visibleSlides = [];
        this.removeObservers();
        this.initializeElements();
        this.setupEventListeners();
        this.setupObservers();
        this.handleInitialSlide();
        if (this.autoplay && this.loop) requestAnimationFrame(this.play);
      };
      duplicateSlides = () => {
        if (!this.slider || !this.loop || !this.slidesPerView && !this.slidesPerViewMobile) return;
        const minRequiredSlides = Math.max(this.slidesPerView ?? 0, this.slidesPerViewMobile ?? 0) + SLIDES_QTY_MARGIN;
        if (this.slides.length === 0 || this.slides.length >= minRequiredSlides) return;
        const originalSlides = this.slides.filter(slide => slide != undefined);
        while (this.slides.length < minRequiredSlides) {
          const dupSlides = originalSlides.map(slide => slide.cloneNode(true));
          dupSlides.forEach((slide, index) => {
            slide.dataset.dupOriginIndex = index.toString();
            if (this.slider) this.slider.appendChild(slide);
          });
          this.slides = this.slides.concat(dupSlides);
        }
      };
      play = timeStamp => {
        if (!this.slider || this.isVisible === false) {
          this.isFirstFrame = true;
          return;
        }
        if (this.autoplay) requestAnimationFrame(this.play);
        if (this.isFirstFrame) {
          this.oldTimeStamp = timeStamp;
          this.isFirstFrame = false;
          return;
        }
        this.secondsPassed = (timeStamp - this.oldTimeStamp) / 1000;
        if (this.isUserInteracting()) {
          this.oldTimeStamp = timeStamp;
          return;
        }
        const distance = this.autoplaySpeed * this.secondsPassed;
        if (distance >= SCROLL_MIN_DISTANCE) {
          const distanceRemainder = mod(distance, SCROLL_MIN_DISTANCE);
          this.slides.forEach(slide => slide.style.transform = `translateX(${distanceRemainder * this.autoplayDirection * -1}px)`);
          this.slider.scrollLeft = this.slider.scrollLeft + distance * this.autoplayDirection;
          this.oldTimeStamp = timeStamp;
        } else {
          this.slides.forEach(slide => slide.style.transform = `translateX(${distance * this.autoplayDirection * -1}px)`);
        }
      };
      isUserInteracting = () => this.isHovered || this.isFocused || this.isDragging || this.isTouching;
      handleKeydown = e => {
        if (e.key === 'Tab') this.handleTab(e);
      };
      handleSlideVisibilityChange = entries => {
        try {
          entries.forEach(entry => {
            const slide = entry.target;
            const isVisible = entry.isIntersecting;
            if (isVisible) {
              this.addVisibleSlide(slide);
              if (this.loop) this.looping(slide);
            } else this.removeVisibleSlide(slide);
            this.visibleSlides.sort((slideA, slideB) => slideA.offsetLeft - slideB.offsetLeft);
            this.handleActiveSlide();
            this.setSlideAccessibility(slide, isVisible);
            this.handleButtonState();
            if (this.visibleSlides[0]) this.lastVisibleSlide = this.visibleSlides[0];
          });
        } catch (error) {}
      };
      setSlideAccessibility = (slide, isVisible) => {
        if (isVisible) {
          slide.setAttribute('tabindex', slide.dataset.initialTabIndex ?? '0');
          slide.setAttribute('aria-hidden', 'false');
          Array.from(slide.querySelectorAll(FOCUSABLE_SELECTORS)).forEach(child => {
            child.setAttribute('tabindex', child.dataset.initialTabIndex ?? '0');
          });
        } else {
          slide.dataset.initialTabIndex = slide.tabIndex.toString() ?? '0';
          slide.setAttribute('tabindex', '-1');
          slide.setAttribute('aria-hidden', 'true');
          Array.from(slide.querySelectorAll(FOCUSABLE_SELECTORS)).forEach(child => {
            child.dataset.initialTabIndex = child.tabIndex.toString() ?? '0';
            child.setAttribute('tabindex', '-1');
          });
        }
      };
      addVisibleSlide = slide => {
        try {
          if (!this.slider) return;
          const sliderRect = this.slider.getBoundingClientRect();
          const sliderCenterX = sliderRect.x + sliderRect.width / 2;
          const slideRect = slide.getBoundingClientRect();
          const slideCenterX = slideRect.x + slideRect.width / 2;
          if (slideCenterX <= sliderCenterX) this.visibleSlides.unshift(slide);else this.visibleSlides.push(slide);
        } catch (error) {}
      };
      removeVisibleSlide = slide => {
        if (this.visibleSlides.length <= 0) return;
        if (slide === this.visibleSlides[0]) this.visibleSlides.shift();else if (slide === this.visibleSlides[this.visibleSlides.length - 1]) this.visibleSlides.pop();else {
          const index = this.visibleSlides.findIndex(item => item === slide);
          if (index > -1) this.visibleSlides.splice(index, 1);
        }
      };
      initializeIndexes = () => {
        const autoInitDots = this.showDots && this.slides.length !== this.dots.length;
        if (autoInitDots && this.dotsContainer) {
          this.dotsContainer.innerHTML = '';
          this.dots = [];
        }
        this.slides.forEach((slide, index) => {
          if (!slide) return;
          slide.dataset.index = index;
          slide.dataset.initialTabIndex = slide.tabIndex.toString();
          if (autoInitDots && this.dotsContainer && !slide.dataset.dupOriginIndex) {
            const dotSpan = document.createElement('span');
            dotSpan.setAttribute('data-ref', 'slider-dot');
            dotSpan.dataset.index = index;
            this.dotsContainer.appendChild(dotSpan);
            this.dots.push(dotSpan);
          }
        });
      };
      handleButtonState = () => {
        if (this.loop || !this.prevBtn || !this.nextBtn) return;
        const firstVisibleSlide = this.visibleSlides[0];
        const lastVisibleSlide = this.visibleSlides[this.visibleSlides.length - 1];
        if (firstVisibleSlide === this.slides[0]) {
          this.prevBtn.disabled = true;
          this.customPrevBtns.forEach(btn => btn.disabled = true);
        } else {
          this.prevBtn.disabled = false;
          this.customPrevBtns.forEach(btn => btn.disabled = false);
        }
        if (lastVisibleSlide === this.slides[this.slides.length - 1]) {
          this.nextBtn.disabled = true;
          this.customNextBtns.forEach(btn => btn.disabled = true);
        } else {
          this.nextBtn.disabled = false;
          this.customNextBtns.forEach(btn => btn.disabled = false);
        }
      };
      handleWheel = e => {
        if (!document.body.classList.contains('fullscreen-active') && Math.abs(e.deltaY) > Math.abs(e.deltaX)) window.scroll({
          top: window.scrollY + e.deltaY,
          behavior: 'instant'
        });
      };
      handleMouseEnter = () => {
        this.isHovered = true;
      };
      handleMouseLeave = () => {
        this.isHovered = false;
      };
      handleFocusIn = () => {
        this.isFocused = true;
      };
      handleFocusOut = () => {
        this.isFocused = false;
      };
      handleScroll = () => {
        this.isScrolling = true;
      };
      handleScrollEnd = () => {
        this.isScrolling = false;
        this.swipeLocked = false;
      };
      handleTouchStart = e => {
        this.isTouching = true;
        if (!this.slider) return;
        if (e.touches.length !== 1) {
          this.touchId = null;
          this.touchIntent = 'none';
          return;
        }
        const t = e.touches[0];
        this.touchId = t.identifier;
        this.touchStartX = t.clientX;
        this.touchStartY = t.clientY;
        this.lastTouchY = t.clientY;
        this.touchIntent = 'none';
      };
      handleTouchMove = e => {
        try {
          if (!this.slider) return;
          if (this.touchId === null) return;
          const t = Array.from(e.touches).find(tt => tt.identifier === this.touchId);
          if (!t) return;
          const dx = t.clientX - this.touchStartX;
          const dy = t.clientY - this.touchStartY;
          const absX = Math.abs(dx);
          const absY = Math.abs(dy);
          if (this.touchIntent === 'none') {
            if (absX < 6 && absY < 6) return;
            this.touchIntent = absX > absY + 4 ? 'x' : 'y';
          }
          if (this.touchIntent === 'y') {
            if (document.body.classList.contains('fullscreen-active')) return;
            e.preventDefault();
            const currentY = t.clientY;
            const deltaY = this.lastTouchY - currentY;
            window.scrollBy({
              top: deltaY,
              behavior: 'instant'
            });
            this.lastTouchY = currentY;
            return;
          }
          if (!this.centered && !this.lockSwipeOnScroll) return;
          e.preventDefault();
          if (this.swipeLocked) return;
          if (absX < 20) return;
          const dir = dx < 0 ? 1 : -1;
          if (dir > 0) this.handleNext();else this.handlePrev();
          this.swipeLocked = true;
          const unlock = () => {
            this.swipeLocked = false;
          };
          addScrollEndListener(this.slider, unlock, {
            once: true,
            signal: this.controller?.signal
          });
          window.setTimeout(unlock, 600);
        } catch (error) {}
      };
      handleTouchEnd = () => {
        this.isTouching = false;
        this.touchId = null;
        this.touchIntent = 'none';
      };
      handleTouchCancel = () => {
        this.isTouching = false;
        this.touchId = null;
        this.touchIntent = 'none';
      };
      handleMousedown = event => {
        event.preventDefault();
        if (this.isMouseDown || !this.slider) return;
        this.isMouseDown = true;
        this.dragStartX = event.clientX;
        document.addEventListener('mousemove', this.handleMousemove, {
          signal: this.controller?.signal
        });
        document.addEventListener('mouseup', this.handleMouseup, {
          once: true,
          signal: this.controller?.signal
        });
        document.addEventListener('mouseleave', this.handleMouseup, {
          once: true,
          signal: this.controller?.signal
        });
      };
      handleMousemove = event => {
        if (!this.isMouseDown || !this.slider) return;
        this.dragCurrentX = event.clientX;
        const deltaX = this.dragCurrentX - this.dragStartX;
        if (!this.isDragging) {
          const totalMovement = Math.abs(deltaX);
          if (totalMovement < DRAG_TOLERANCE) return;
          this.isDragging = true;
          this.slider.classList.add('is-dragging');
        }
        this.slider.scrollLeft = this.slider?.scrollLeft - deltaX;
        this.dragStartX = this.dragCurrentX;
        if (this.dragTimeout) {
          clearTimeout(this.dragTimeout);
          this.dragTimeout = null;
        }
      };
      handleMouseup = event => {
        this.isMouseDown = false;
        document.removeEventListener('mousemove', this.handleMousemove);
        if (!this.isDragging || !this.slider) return;
        event.preventDefault();
        event.stopPropagation();
        this.isDragging = false;
        this.dragTimeout = setTimeout(() => this.slider?.classList.remove('is-dragging'), 150);
        this.snapToNearestSlide();
      };
      snapToNearestSlide = () => {
        if (!this.slider) return;
        if (this.centered) {
          const sliderRect = this.slider.getBoundingClientRect();
          const sliderCenterX = sliderRect.left + sliderRect.width / 2;
          const candidates = this.visibleSlides.length ? this.visibleSlides : this.slides;
          let nearest;
          let minDist = Infinity;
          for (const s of candidates) {
            const r = s.getBoundingClientRect();
            const cx = r.left + r.width / 2;
            const d = Math.abs(cx - sliderCenterX);
            if (d < minDist) {
              minDist = d;
              nearest = s;
            }
          }
          if (nearest) this.scrollToSlide(nearest);
          return;
        }
        if (this.lastVisibleSlide) this.scrollToSlide(this.lastVisibleSlide);
      };
      handleNext = () => {
        if (this.slideFullPage) {
          const nextVisibleIndex = this.visibleSlides.length - 1;
          const nextVisibleSlide = this.visibleSlides[nextVisibleIndex];
          const limitIndex = this.loop ? this.slides.length - 1 : this.slides.length - this.visibleSlides.length;
          if (!nextVisibleSlide) return;
          const targetIndex = +(nextVisibleSlide.dataset.index ?? this.slides.findIndex(slide => slide === nextVisibleSlide));
          if (targetIndex < 0) return;
          let nextIndex = targetIndex + 1;
          if (this.loop) nextIndex = mod(nextIndex, this.slides.length);
          if (nextIndex <= limitIndex && nextIndex >= 0) {
            const nextSlide = this.slides[nextIndex];
            if (nextSlide) this.scrollToSlide(nextSlide);
          } else {
            const lastSlide = this.slides[limitIndex];
            if (lastSlide) this.scrollToSlide(lastSlide);
          }
        } else {
          if (this.activeIndex === undefined) return;
          let nextIndex = this.activeIndex + this.slidesToScroll;
          if (this.loop) {
            nextIndex = mod(nextIndex, this.slides.length);
          } else if (nextIndex >= this.slides.length) {
            nextIndex = this.slides.length - 1;
          }
          const nextSlide = this.slides[nextIndex];
          if (nextSlide) {
            this.scrollToSlide(nextSlide);
          }
        }
      };
      handlePrev = () => {
        if (this.slideFullPage) {
          const firstVisibleSlide = this.visibleSlides[0];
          if (!firstVisibleSlide) {
            return;
          }
          const firstVisibleIndex = +(firstVisibleSlide.dataset.index ?? this.slides.findIndex(slide => slide === firstVisibleSlide));
          if (firstVisibleIndex < 0) return;
          let prevIndex = firstVisibleIndex - this.visibleSlides.length;
          if (this.loop) {
            prevIndex = mod(prevIndex, this.slides.length);
          }
          if (prevIndex >= 0 && prevIndex < this.slides.length) {
            const prevSlide = this.slides[prevIndex];
            if (prevSlide) {
              this.scrollToSlide(prevSlide);
            }
          }
        } else {
          if (this.activeIndex === undefined) return;
          let prevIndex = this.activeIndex - this.slidesToScroll;
          if (this.loop) {
            prevIndex = mod(prevIndex, this.slides.length);
          } else if (prevIndex < 0) {
            prevIndex = 0;
          }
          const prevSlide = this.slides[prevIndex];
          if (prevSlide) {
            this.scrollToSlide(prevSlide);
          }
        }
      };
      handleActiveSlide = () => {
        let activeSlide;
        if (this.centered && this.slider) {
          const sliderRect = this.slider.getBoundingClientRect();
          const sliderCenterX = sliderRect.left + sliderRect.width / 2;
          const candidates = this.visibleSlides.length ? this.visibleSlides : this.slides;
          let minDist = Infinity;
          for (const s of candidates) {
            const r = s.getBoundingClientRect();
            const cx = r.left + r.width / 2;
            const d = Math.abs(cx - sliderCenterX);
            if (d < minDist) {
              minDist = d;
              activeSlide = s;
            }
          }
        } else {
          activeSlide = this.visibleSlides[0];
        }
        if (!activeSlide) return;
        const activeIndex = +(activeSlide?.dataset.index ?? this.slides.findIndex(slide => slide === activeSlide) ?? -1);
        if (activeIndex < 0) return;
        if (this.activeIndex !== activeIndex) {
          this.activeIndex = activeIndex;
          if (this.ownerEl) this.ownerEl.dispatchEvent(new CustomEvent(ACTIVE_SLIDE_CHANGE, {
            detail: {
              slideIndex: activeIndex
            }
          }));
        }
        if (this.showDots) this.handleDots(activeSlide.dataset.dupOriginIndex ? +activeSlide.dataset.dupOriginIndex : activeIndex);
      };
      handleDots = index => {
        const newActiveDot = this.dots[index];
        if (!newActiveDot) return;
        if (this.activeDot && this.activeDot !== newActiveDot) {
          this.activeDot.classList.remove('active');
        }
        if (!newActiveDot.classList.contains('active')) {
          newActiveDot.classList.add('active');
          this.activeDot = newActiveDot;
        }
      };
      handleInitialSlide = () => {
        let targetSlide = undefined;
        if (this.initialSlideIndex) targetSlide = this.slides.find(slide => slide?.dataset.index == this.initialSlideIndex);else targetSlide = this.slides.find(slide => slide?.classList.contains('active'));
        if (!targetSlide && this.centered) targetSlide = this.slides[0];
        if (targetSlide) {
          setTimeout(() => {
            this.scrollToSlide(targetSlide, false);
          }, INIT_SCROLL_DELAY);
          this.activeIndex = targetSlide?.dataset.index ?? this.slides.findIndex(slide => slide === targetSlide);
        } else {
          this.activeIndex = 0;
        }
      };
      looping = slide => {
        if (slide === this.lastSlide) this.moveFirstChildToLast();
        if (slide === this.firstSlide) this.moveLastChildToFirst();
      };
      moveFirstChildToLast = () => {
        try {
          if (!this.slider || !this.firstSlide) return;
          const newFirst = this.firstSlide.nextElementSibling;
          if (!newFirst) return;
          const slideContain3DViewer = this.firstSlide.querySelector('product-xyz-3d');
          this.slider.classList.add('no-scroll-snap');
          this.slider.appendChild(this.firstSlide);
          this.lastSlide = this.firstSlide;
          this.firstSlide = newFirst;
          const scrollLeft = this.slider.scrollLeft - (this.lastSlide.clientWidth + this.gap);
          this.slider?.scrollTo({
            left: scrollLeft,
            behavior: 'instant'
          });
          this.slider.classList.remove('no-scroll-snap');
          if (slideContain3DViewer) {
            slideContain3DViewer.toggleViewer();
          }
        } catch (error) {}
      };
      moveLastChildToFirst = () => {
        try {
          if (!this.slider || !this.lastSlide) return;
          const newLast = this.lastSlide.previousElementSibling;
          if (!newLast) return;
          const slideContain3DViewer = this.lastSlide.querySelector('product-xyz-3d');
          this.slider.classList.add('no-scroll-snap');
          this.slider.insertBefore(this.lastSlide, this.slider.firstElementChild);
          this.firstSlide = this.lastSlide;
          this.lastSlide = newLast;
          const scrollLeft = this.slider.scrollLeft + (this.firstSlide.clientWidth + this.gap);
          this.slider.scrollTo({
            left: scrollLeft,
            behavior: 'instant'
          });
          this.slider.classList.remove('no-scroll-snap');
          if (slideContain3DViewer) {
            slideContain3DViewer.toggleViewer();
          }
        } catch (error) {}
      };
      calculateTargetScrollLeft = target => {
        if (!this.slider) return 0;
        let scrollLeft = this.slider.scrollLeft;
        if (this.centered) {
          const targetCenter = target.offsetLeft + target.clientWidth / 2;
          const containerCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;
          const delta = targetCenter - containerCenter;
          scrollLeft = this.slider.scrollLeft + delta;
        } else {
          const slideRect = target.getBoundingClientRect();
          const containerRect = this.slider.getBoundingClientRect();
          scrollLeft = this.slider.scrollLeft + (slideRect.left - containerRect.left);
        }
        return scrollLeft;
      };
      addAdjustmentOnScrollEnd = (initialScrollLeft, targetSlide) => {
        if (!this.slider) return;
        addScrollEndListener(this.slider, () => {
          if (!this.slider) return;
          if (Math.round(this.slider.scrollLeft) != Math.round(initialScrollLeft)) {
            const scrollLeft = this.calculateTargetScrollLeft(targetSlide);
            this.slider.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        }, {
          once: true,
          signal: this.controller?.signal
        });
      };
      scrollToSlide = (targetSlide, focus = true) => {
        try {
          if (!this.slider) return;
          const scrollLeft = this.calculateTargetScrollLeft(targetSlide);
          if (this.centered) this.addAdjustmentOnScrollEnd(scrollLeft, targetSlide);
          this.slider.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
          if (focus) this.focusAfterScroll(this.slider.scrollLeft, scrollLeft);
        } catch (error) {}
      };
      focusAfterScroll = (initialLeft, targetLeft) => {
        if (!this.slider || initialLeft === targetLeft) return;
        const handleScrollEndFocus = () => {
          if (initialLeft < targetLeft) {
            if (this.slideFullPage) this.getFocusableElem(this.visibleSlides[0])?.focus();else this.getFocusableElem(this.visibleSlides[this.visibleSlides.length - 1])?.focus();
          } else {
            if (this.slideFullPage) this.getFocusableElem(this.visibleSlides[this.visibleSlides.length - 1])?.focus();else this.getFocusableElem(this.visibleSlides[0])?.focus();
          }
        };
        addScrollEndListener(this.slider, handleScrollEndFocus, {
          once: true,
          signal: this.controller?.signal
        });
      };
      getFocusableElem(root) {
        if (isFocusable(root)) return root;
        return root.querySelector(FOCUSABLE_SELECTORS);
      }
      checkIsFocused = element => {
        return document.activeElement === element || element?.contains(document.activeElement);
      };
      handleTab = e => {
        const isReverseTabbing = e.shiftKey;
        if (isReverseTabbing && this.checkIsFocused(this.slides[0])) {
          e.preventDefault();
          this.prevBtn?.focus();
        }
        if (!isReverseTabbing && this.checkIsFocused(this.slides[this.slides.length - 1])) {
          e.preventDefault();
          this.nextBtn?.focus();
        }
      };
      areAllSlidesVisible = () => {
        try {
          if (!this.slider || this.slides.length === 0) return false;
          return this.visibleSlides.length === this.slides.length;
        } catch (error) {
          return false;
        }
      };
      scrollToIndex = index => {
        if (index >= this.slides.length || index < 0) return;
        const slide = this.slides[index];
        this.scrollToSlide(slide);
      };
      static define = () => {
        if (!customElements.get('component-slider')) {
          customElements.define('component-slider', ComponentSlider);
        }
      };
    }
    var componentSlider = () => {
      ComponentSlider.define();
    };

    var componentSlider$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentSlider: ComponentSlider,
        default: componentSlider
    });

    const {
      getElementByRef: getElementByRef$d
    } = window.PoleneLibs.Refs;
    class ComponentAccordion extends HTMLElement {
      content = undefined;
      counter = undefined;
      observer = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupObserver();
        AccordionUtils.init();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      initializeElements = () => {
        const {
          accordionCounter,
          accordionContent
        } = getElementByRef$d(['accordion-counter', 'accordion-content'], this);
        this.content = accordionContent;
        this.counter = accordionCounter;
        if (this.content && this.counter) this.counter.innerText = (this.content.childElementCount ?? 0).toString();
      };
      setupObserver = () => {
        if (!this.content || !this.counter) return;
        this.observer = new MutationObserver(() => {
          if (this.content && this.counter) this.counter.innerText = (this.content.childElementCount ?? 0).toString();
        });
        this.observer.observe(this.content, {
          childList: true
        });
      };
      static define = () => {
        if (!customElements.get('component-accordion')) customElements.define('component-accordion', ComponentAccordion);
      };
    }
    var componentAccordion = () => {
      ComponentAccordion.define();
    };

    var componentAccordion$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentAccordion
    });

    const {
      getElementsByRef: getElementsByRef$6,
      getRefs: getRefs$8
    } = window.PoleneLibs.Refs;
    const {
      storeLanguage
    } = window.PoleneLibs.ConstantsDate;
    var componentNewsletterSignup = () => {
      const {
        newsletterSignup
      } = getElementsByRef$6('newsletter-signup');
      const newsletterSignups = Array.isArray(newsletterSignup) ? [...newsletterSignup] : [newsletterSignup];
      if (!newsletterSignup || newsletterSignups.length === 0) return;
      const cleaners = [];
      newsletterSignups.forEach(signupContainer => {
        const {
          signupForm,
          formInput,
          messageContainer
        } = getRefs$8(signupContainer);
        const {
          messageSuccess,
          messageError,
          messageAlreadySubscribed,
          messageNotValidEmail,
          klaviyoEventKey
        } = signupForm.dataset;
        if (!messageContainer || !signupForm || !formInput) return;
        const init = () => {
          setEventListeners();
        };
        const setEventListeners = () => {
          signupForm.addEventListener('submit', handleSubmit);
        };
        const removeEventListeners = () => {
          signupForm.removeEventListener('submit', handleSubmit);
        };
        const handleSubmit = async e => {
          e.preventDefault();
          if (!formInput) return;
          if (!validateEmail(formInput.value)) {
            messageContainer.innerHTML = `<p class="ts-error">${messageNotValidEmail}</p>`;
            return;
          }
          const formData = new FormData();
          formData.set('email', formInput.value);
          formData.set('locale', storeLanguage);
          if (klaviyoEventKey) formData.set('event', klaviyoEventKey);
          try {
            const response = await fetch(`${API_PROXY.MARKETING_SUBSCRIBE}`, {
              method: 'POST',
              body: formData
            });
            handleResponse(response);
          } catch {
            messageContainer.innerHTML = `<p class="ts-error">${messageError}</p>`;
          }
        };
        const handleResponse = async res => {
          if (res.status === 200) {
            messageContainer.innerHTML = `<p>${messageSuccess}</p>`;
          } else if (res.status === 409) {
            messageContainer.innerHTML = `<p>${messageAlreadySubscribed}</p>`;
          } else {
            messageContainer.innerHTML = `<p class="ts-error">${messageError}</p>`;
          }
          formInput.value = '';
        };
        init();
        cleaners.push(removeEventListeners);
      });
      return () => {
        cleaners.forEach(cleanup => cleanup());
      };
    };

    var componentNewsletterSignup$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentNewsletterSignup
    });

    class ComponentSnackbar extends HTMLElement {
      autoHideDuration = 3000;
      hideTimer = undefined;
      showTimer = undefined;
      static snackbarInstances = {};
      static defaultSnackbar = null;
      static activeSnackbar = null;
      static SHOW_DELAY = 300;
      constructor() {
        super();
      }
      connectedCallback() {
        this.autoHideDuration = this.dataset.displayDuration ? +this.dataset.displayDuration : this.autoHideDuration;
      }
      resetActiveSnackbar = () => {
        clearTimeout(this.showTimer);
        this.showTimer = undefined;
        ComponentSnackbar.activeSnackbar?.dismiss();
        ComponentSnackbar.activeSnackbar = null;
      };
      show = innerHTML => {
        const isSnackbarActive = !!ComponentSnackbar.activeSnackbar;
        this.resetActiveSnackbar();
        if (innerHTML) this.innerHTML = innerHTML;
        this.showTimer = setTimeout(() => {
          this.classList.add('active');
          ComponentSnackbar.activeSnackbar = this;
        }, isSnackbarActive ? ComponentSnackbar.SHOW_DELAY : 0);
        this.hideTimer = setTimeout(() => {
          this.resetActiveSnackbar();
        }, isSnackbarActive ? ComponentSnackbar.SHOW_DELAY + this.autoHideDuration : this.autoHideDuration);
      };
      dismiss = () => {
        clearTimeout(this.hideTimer);
        this.classList.remove('active');
        this.hideTimer = undefined;
      };
      static open = ({
        templateId,
        innerHTML
      }) => {
        const selector = `component-snackbar${templateId ? '#snackbar-' + templateId : ''}`;
        let instance = null;
        if (templateId) instance = this.snackbarInstances[templateId] ?? document.body.querySelector(selector);else {
          if (!this.defaultSnackbar) this.defaultSnackbar = document.body.querySelector(selector);
          instance = this.defaultSnackbar;
        }
        if (instance) instance.show(innerHTML);
      };
      static define() {
        if (!customElements.get('component-snackbar')) customElements.define('component-snackbar', ComponentSnackbar);
      }
    }
    var componentSnackbar = () => {
      ComponentSnackbar.define();
    };

    var componentSnackbar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentSnackbar: ComponentSnackbar,
        default: componentSnackbar
    });

    const SnackbarTemplate = {
      ERROR: 'error',
      ADD_TO_WISHLIST: 'add-to-wishlist',
      REMOVE_FROM_WISHLIST: 'remove-from-wishlist'
    };

    const {
      getElementByRef: getElementByRef$c
    } = window.PoleneLibs.Refs;
    class ComponentAddToWishlist extends HTMLElement {
      isInWishlist = false;
      constructor() {
        super();
        this.controller = new AbortController();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.updateWishlistState();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.controller.abort();
      }
      updatedCallback() {
        this.controller.abort();
        this.controller = new AbortController();
        this.initializeElements();
        this.updateWishlistState();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      initializeElements = () => {
        const {
          iconHeartFilled,
          buttonTextAdd,
          buttonTextAlready
        } = getElementByRef$c(['icon-heart-filled', 'button-text-add', 'button-text-already'], this);
        this.buttonTextAdd = buttonTextAdd;
        this.buttonTextAlready = buttonTextAlready;
        this.iconHeartFilled = iconHeartFilled;
        this.productId = this.dataset.productId;
      };
      setupEventListeners = () => {
        this.addEventListener('click', this.handleClick, {
          signal: this.controller.signal
        });
      };
      setupAccessibility = () => {
        this.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleClick(e);
          }
        }, {
          signal: this.controller.signal
        });
      };
      updateWishlistState = () => {
        if (!this.productId) return;
        this.isInWishlist = Wishlist.isInWishlist(this.productId);
        this.syncUI();
      };
      syncUI = () => {
        if (this.isInWishlist) {
          this.iconHeartFilled?.classList.remove('hidden');
          this.ariaPressed = 'true';
          if (this.buttonTextAlready && this.buttonTextAdd) {
            this.buttonTextAdd.classList.add('hidden');
            this.buttonTextAlready.classList.remove('hidden');
            this.classList.add('already');
            this.removeAttribute('role');
          }
        } else {
          this.iconHeartFilled?.classList.add('hidden');
          this.ariaPressed = 'false';
          if (this.buttonTextAlready && this.buttonTextAdd) {
            this.buttonTextAdd.classList.remove('hidden');
            this.buttonTextAlready.classList.add('hidden');
            this.classList.remove('already');
            this.setAttribute('role', 'button');
          }
        }
        if (this.dataset.addLabel && this.dataset.removeLabel) this.ariaLabel = this.isInWishlist ? this.dataset.removeLabel : this.dataset.addLabel;
      };
      handleClick = async e => {
        e.preventDefault();
        if (e.target instanceof HTMLAnchorElement) {
          window.location.href = e.target.href;
          return;
        }
        if (this.isInWishlist && this.buttonTextAlready) {
          return;
        }
        if (!this.productId || !this.iconHeartFilled) return;
        this.iconHeartFilled.classList.toggle('hidden', this.isInWishlist);
        if (this.buttonTextAlready && this.buttonTextAdd) {
          this.buttonTextAdd.classList.toggle('hidden');
          this.buttonTextAlready.classList.toggle('hidden');
          this.classList.toggle('already');
        }
        const success = await (this.isInWishlist ? Wishlist.remove(this.productId) : Wishlist.add(this.productId));
        if (success) {
          this.isInWishlist = !this.isInWishlist;
          ComponentSnackbar.open({
            templateId: this.isInWishlist ? SnackbarTemplate.ADD_TO_WISHLIST : SnackbarTemplate.REMOVE_FROM_WISHLIST
          });
        } else ComponentSnackbar.open({
          templateId: SnackbarTemplate.ERROR
        });
        this.syncUI();
      };
      static define = () => {
        if (!customElements.get('component-add-to-wishlist')) customElements.define('component-add-to-wishlist', ComponentAddToWishlist);
      };
    }
    var componentAddToWishlist = () => {
      ComponentAddToWishlist.define();
    };

    var componentAddToWishlist$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentAddToWishlist
    });

    const {
      getElementByRef: getElementByRef$b
    } = window.PoleneLibs.Refs;
    class WishlistCounter extends HTMLElement {
      counterEl = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = async () => {
        const {
          wishlistCounter
        } = getElementByRef$b('wishlist-counter', this);
        this.counterEl = wishlistCounter;
        if (this.counterEl) this.counterEl.innerText = Wishlist.count().toString();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.handleWishlistUpdate);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.handleWishlistUpdate);
      };
      handleWishlistUpdate = productIds => {
        if (this.counterEl) this.counterEl.innerText = productIds.length.toString();
      };
      static define = () => {
        if (!customElements.get('wishlist-counter')) customElements.define('wishlist-counter', WishlistCounter);
      };
    }
    var wishlistCounter = () => {
      WishlistCounter.define();
    };

    var wishlistCounter$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistCounter
    });

    class WishlistGrid extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = async () => {
        this.renderGrid();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.renderGrid);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.renderGrid);
      };
      renderGrid = async () => {
        const grid = await Wishlist.getHTML();
        if (grid) {
          this.innerHTML = grid;
          this.classList.remove('hidden');
        } else this.classList.add('hidden');
      };
      static define = () => {
        if (!customElements.get('wishlist-grid')) customElements.define('wishlist-grid', WishlistGrid);
      };
    }
    var wishlistGrid = () => {
      WishlistGrid.define();
    };

    var wishlistGrid$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistGrid
    });

    const {
      getElementByRef: getElementByRef$a
    } = window.PoleneLibs.Refs;
    class WishlistStateBlock extends HTMLElement {
      emptyWishlistText = undefined;
      saveWishlistText = undefined;
      isLoggedIn = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = async () => {
        const {
          wishlistSaveText,
          wishlistEmptyText
        } = getElementByRef$a(['wishlist-save-text', 'wishlist-empty-text'], this);
        this.saveWishlistText = wishlistSaveText;
        this.emptyWishlistText = wishlistEmptyText;
        if (this.emptyWishlistText && this.saveWishlistText) this.isLoggedIn = true;
        this.syncUI();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.syncUI);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.syncUI);
      };
      syncUI = () => {
        const isEmpty = Wishlist.count() === 0;
        if (this.isLoggedIn) {
          this.emptyWishlistText?.classList.toggle('hidden', !isEmpty);
          this.saveWishlistText?.classList.toggle('hidden', isEmpty);
        } else this.classList.toggle('hidden', !isEmpty);
      };
      static define = () => {
        if (!customElements.get('wishlist-state-block')) customElements.define('wishlist-state-block', WishlistStateBlock);
      };
    }
    var wishlistStateBlock = () => {
      WishlistStateBlock.define();
    };

    var wishlistStateBlock$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistStateBlock
    });

    const {
      breakpoints: breakpoints$4
    } = window.PoleneLibs.Breakpoints;
    const events$4 = window.PoleneLibs.Events.default;
    const scrollLock$3 = window.PoleneLibs.ScrollLock.default;
    const {
      dispatchEvent: dispatchEvent$2
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$9,
      getRefs: getRefs$7
    } = window.PoleneLibs.Refs;
    const selectors$5 = {
      closeBtn: '.js-close',
      productForm: '.js-product-form',
      sizeSelector: '.js-size-selector',
      bg: '.js-notification-bg'
    };
    const classes$8 = {
      active: 'is-active',
      visible: 'is-visible',
      hidden: 'is-hidden',
      preorderInput: 'preorder-note'
    };
    const states = {
      variantSelector: 'variant-selector',
      productAdded: 'product-added',
      preorder: 'preorder'
    };
    const {
      select_size,
      add_to_cart,
      added_to_cart,
      preorder_subtitle
    } = window.translations;
    let xDown = null;
    let yDown = null;
    let isOpen$1 = false;
    let isProcessingCartUpdate = false;
    const isMobile$1 = () => window.innerWidth < breakpoints$4.md;
    var fragmentCartNotification = () => {
      const {
        cartNotification
      } = getElementByRef$9('cart-notification');
      let popUpTimeouts = [];
      if (!cartNotification) return;
      const {
        notificationTitle,
        notificationSubtitle,
        notificationFormtitle,
        notificationProduct,
        notificationProductForm
      } = getRefs$7(cartNotification);
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        window.addEventListener(events$4.CART_UPDATED, handleCartUpdated);
        window.addEventListener(events$4.TRIGGER_NOTIFICATION_LAYOUT, toggleLayout);
        document.addEventListener('touchstart', handleTouchStart, false);
        document.addEventListener('touchmove', handleTouchMove, false);
        cartNotification.addEventListener('click', handleClick);
      };
      const handleCartUpdated = e => {
        if (window.location.pathname === '/cart') {
          closePopUp();
          return;
        }
        if (isProcessingCartUpdate) return;
        if (!e.detail?.sections['cart-notification-product']) return;
        isProcessingCartUpdate = true;
        popUpTimeouts.forEach(timeout => clearTimeout(timeout));
        popUpTimeouts = [];
        let parser = new DOMParser();
        let markup = parser.parseFromString(e.detail.sections['cart-notification-product'], 'text/html');
        const productCard = markup.documentElement.querySelector(`[id="cart-notification-product-${e.detail.items[0].key}"]`);
        if (!productCard) {
          isProcessingCartUpdate = false;
          return;
        }
        notificationProduct.innerHTML = productCard.innerHTML;
        openPopUp(states.productAdded);
        popUpTimeouts.push(Number(setTimeout(() => {
          closePopUp();
        }, 4000)));
        setTimeout(() => {
          isProcessingCartUpdate = false;
        }, 500);
      };
      const toggleLayout = async e => {
        if (isProcessingCartUpdate && isOpen$1) return;
        let {
          element,
          handle,
          className,
          state
        } = e.detail;
        popUpTimeouts.forEach(timeout => clearTimeout(timeout));
        popUpTimeouts = [];
        notificationProduct.innerHTML = '';
        notificationProductForm.innerHTML = '';
        notificationSubtitle.innerHTML = '';
        if (className) element.classList.add(className);
        if (handle) {
          const element = await createProductPreview(handle);
          if (element) notificationProduct.innerHTML = element.innerHTML;
        }
        if (element) notificationProductForm.appendChild(element);
        if (state === states.preorder) {
          const preOrderInput = element.getElementsByClassName(classes$8.preorderInput);
          const shippingInfo = preOrderInput[0].value;
          const preorderSubtitle = preorder_subtitle.replace('{{ shippingInfo }}', shippingInfo);
          notificationSubtitle.innerHTML = preorderSubtitle;
        }
        if (cartNotification.querySelector(selectors$5.productForm)) cartNotification.querySelector(selectors$5.productForm)?.addEventListener('input', handleFormChange);
        openPopUp(states[state]);
      };
      const closePopUp = () => {
        updateState(false);
        const delay = isMobile$1() ? 150 : 600;
        cartNotification.classList.add(classes$8.hidden);
        cartNotification.classList.remove(classes$8.active);
        cartNotification.setAttribute('aria-hidden', 'true');
        notificationProduct.classList.remove(classes$8.visible);
        setTimeout(() => {
          notificationProduct.innerHTML = '';
          notificationTitle.innerHTML = '';
          notificationSubtitle.innerHTML = '';
          notificationFormtitle.innerHTML = '';
          notificationProductForm.innerHTML = '';
          isProcessingCartUpdate = false;
        }, delay);
        popUpTimeouts.forEach(timeout => clearTimeout(timeout));
        popUpTimeouts = [];
      };
      const openPopUp = state => {
        updateState(true);
        cartNotification.dataset.state = state;
        cartNotification.classList.remove(classes$8.hidden);
        cartNotification.classList.add(classes$8.active);
        cartNotification.setAttribute('aria-hidden', 'false');
        const content = {
          [states.variantSelector]: {
            title: add_to_cart,
            formtitle: select_size
          },
          [states.preorder]: {
            title: add_to_cart
          },
          [states.productAdded]: {
            title: added_to_cart
          }
        };
        notificationTitle.innerHTML = content[state].title;
        if (content[state].formtitle) {
          notificationFormtitle.innerHTML = content[state].formtitle;
        }
        if (state == states.productAdded || state == states.preorder || state == states.variantSelector) {
          setTimeout(() => {
            notificationProduct.classList.add(classes$8.visible);
          }, 500);
        }
      };
      const updateState = state => {
        isOpen$1 = state;
        if (isMobile$1()) {
          scrollLock$3(state);
        }
      };
      const createProductPreview = async productHandle => {
        try {
          const fetchUrl = `/products/${productHandle}?section_id=cart-notification-preview&product=${productHandle}`;
          const res = await fetch(fetchUrl);
          const text = await res.text();
          const parser = new DOMParser();
          const markup = parser.parseFromString(text, 'text/html');
          const element = markup.documentElement.querySelector(`[id="notification-product-preview-${productHandle}"]`);
          return element;
        } catch (error) {}
      };
      const handleClick = e => {
        const closeBtn = e.target.closest(selectors$5.closeBtn);
        const productForm = e.target.closest(selectors$5.productForm);
        const sizeSelector = e.target.closest(selectors$5.sizeSelector);
        const bg = e.target.closest(selectors$5.bg);
        if (sizeSelector) {
          return;
        }
        if (closeBtn || bg) {
          closePopUp();
          return;
        }
        if (productForm) {
          e.preventDefault();
          handleAddToCart(productForm);
        }
      };
      const handleFormChange = e => {
        e.preventDefault();
        if (isProcessingCartUpdate) return;
        if (e.target.dataset.availability == 'false') {
          closePopUp();
          dispatchEvent$2(window, events$4.TOGGLE_BIS, {
            variantId: e.target.value
          });
          return;
        } else {
          const productForm = e.target.closest(selectors$5.productForm);
          handleAddToCart(productForm);
        }
      };
      const getTouches = e => {
        return e.touches || e.originalEvent.touches;
      };
      const handleTouchStart = e => {
        if (!isOpen$1) return;
        const firstTouch = getTouches(e)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
      };
      const handleTouchMove = e => {
        if (!xDown || !yDown || !isOpen$1) {
          return;
        }
        var xUp = e.touches[0].clientX;
        var yUp = e.touches[0].clientY;
        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;
        if (Math.abs(xDiff) < Math.abs(yDiff)) {
          if (yDiff > 0) {
            return;
          } else {
            closePopUp();
          }
        }
        xDown = null;
        yDown = null;
      };
      init();
      return () => {
        window.removeEventListener(events$4.CART_UPDATED, handleCartUpdated);
        window.removeEventListener(events$4.TRIGGER_NOTIFICATION_LAYOUT, toggleLayout);
        document.removeEventListener('touchstart', handleTouchStart, false);
        document.removeEventListener('touchmove', handleTouchMove, false);
        cartNotification.removeEventListener('click', handleClick);
        if (cartNotification.querySelector(selectors$5.productForm)) cartNotification.querySelector(selectors$5.productForm)?.removeEventListener('input', handleFormChange);
      };
    };

    var fragmentCartNotification$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentCartNotification
    });

    const events$3 = window.PoleneLibs.Events.default;
    const {
      getElementByRef: getElementByRef$8
    } = window.PoleneLibs.Refs;
    const classes$7 = {
      visible: 'is-visible',
      constrast: 'has-contrast'
    };
    let type = null;
    let isTouchDevice = !document.getElementsByTagName('html')[0].classList.contains('no-touch');
    var fragmentCursor = () => {
      const {
        cursor
      } = getElementByRef$8('cursor');
      if (!cursor || isTouchDevice) return;
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        window.addEventListener(events$3.CHANGE_CURSOR, handleChangeCursor);
        window.addEventListener('mousemove', handleMouseMove);
      };
      const resetCursor = () => {
        document.body.style.cursor = 'auto';
        cursor.classList.remove(classes$7.visible);
      };
      const handleMouseMove = e => {
        const bounds = cursor.getBoundingClientRect();
        const cursorX = e.clientX - bounds.width / 2;
        const cursorY = e.clientY - bounds.height / 2;
        cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
      };
      const handleChangeCursor = e => {
        document.body.style.cursor = 'none';
        type = e.detail.type;
        if (type === 'default') {
          resetCursor();
          return;
        }
        if (e.detail.contrast) {
          cursor.classList.add(classes$7.constrast);
        } else {
          cursor.classList.remove(classes$7.constrast);
        }
        cursor.classList.add(classes$7.visible);
        cursor.dataset.type = e.detail.type;
      };
      init();
      return () => {
        window.removeEventListener(events$3.CHANGE_CURSOR, handleChangeCursor);
        window.removeEventListener('mousemove', handleMouseMove);
        document.body.style.cursor = 'auto';
      };
    };

    var fragmentCursor$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentCursor
    });

    const {
      preorderInputTemplate
    } = window.PoleneLibs.ElementTemplates;
    const events$2 = window.PoleneLibs.Events.default;
    const {
      envelope
    } = window.PoleneLibs.SvgTemplates;
    const {
      dispatchEvent: dispatchEvent$1
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$7,
      getElementsByRef: getElementsByRef$5,
      getRefs: getRefs$6
    } = window.PoleneLibs.Refs;
    const classes$6 = {
      hidden: 'is-hidden',
      open: 'is-open',
      disabled: 'is-disabled',
      preorder: 'is-preorder'
    };
    const selectors$4 = {
      option: '.js-option'
    };
    var fragmentOptionSelect = () => {
      const ref = getElementByRef$7(['grid']);
      const {
        customSelect,
        productDetails,
        searchResults
      } = getElementsByRef$5(['custom-select', 'product-details', 'search-results']);
      if (!ref.grid && !customSelect) return;
      let instances = [];
      const refs = getRefs$6(ref.grid, true);
      const initSelects = () => {
        setTimeout(() => {
          const select = Array.isArray(customSelect) ? [...customSelect] : [customSelect];
          const selectElements = refs && refs.current && Array.isArray(refs.current.customSelect) ? [...refs.current.customSelect] : select;
          selectElements.forEach(selectEl => {
            const selectInstance = initSelect(selectEl);
            if (selectInstance) instances.push(selectInstance);
          });
        });
      };
      const initSelect = selectEl => {
        const {
          select,
          options,
          arrowIcon
        } = getRefs$6(selectEl);
        if (!select) return;
        let selected, container, item;
        selected = document.createElement('div');
        selected.setAttribute('class', `p-select__selected ts-label-s`);
        selected.innerHTML = options[select.selectedIndex].innerHTML;
        const buyBar = document.querySelector('.buy-bar__btn-label-text');
        if (buyBar) buyBar.innerHTML = window.translations?.preorder || buyBar.innerHTML;
        container = document.createElement('div');
        container.setAttribute('class', 'p-select__item-list');
        container.classList.add(classes$6.hidden);
        const handleItemClick = e => {
          const optionEl = e.target.closest(selectors$4.option);
          const optionValue = optionEl.getElementsByClassName('option')[0].innerHTML;
          let selectedIndex;
          options.forEach((option, i) => {
            if (option.innerHTML === optionValue) {
              selectedIndex = i;
            }
          });
          if (optionEl.classList.contains(classes$6.disabled)) {
            e.preventDefault();
            handleToggleList(e);
            dispatchEvent$1(window, events$2.TOGGLE_BIS, {
              variantId: options[selectedIndex].value
            });
            return;
          }
          select.selectedIndex = selectedIndex;
          if (selectEl.nextElementSibling.querySelector('input#pre-order') !== null) {
            selectEl.nextElementSibling.querySelector('input#pre-order').remove();
            selectEl.nextElementSibling.querySelector('input#pre-order-tag').remove();
            selectEl.nextElementSibling.querySelector('input#pre-order-date').remove();
          }
          if (selectEl.nextElementSibling.parentElement.querySelector('div.preorder-description') !== null) {
            selectEl.nextElementSibling.parentElement.querySelector('div.preorder-description').remove();
          }
          if (optionEl.classList.contains(classes$6.preorder)) {
            const preOrderInputProperty = select[selectedIndex].dataset.pol;
            const preOrderInputValue = select[selectedIndex].dataset.pofd;
            const preOrderDate = select[selectedIndex].dataset.pod;
            selectEl.nextElementSibling.dataset.state = 'preorder';
            selectEl.nextElementSibling.dataset.defaultState = 'preorder';
            let input = preorderInputTemplate(preOrderInputProperty, preOrderInputValue, preOrderDate);
            selectEl.nextElementSibling.innerHTML += input;
            selectEl.nextElementSibling.parentElement.insertAdjacentHTML('beforeend', `<div class="preorder-description"> ${preOrderInputValue} </div>`);
          } else {
            selectEl.nextElementSibling.dataset.state = 'default';
            selectEl.nextElementSibling.dataset.defaultState = 'default';
          }
          options.forEach((option, i) => {
            if (option.innerHTML === e.target.innerHTML) {
              select.selectedIndex = i;
            }
          });
          selected.innerHTML = e.target.innerHTML;
          handleToggleList(e);
        };
        const handleToggleList = e => {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          container.classList.toggle(classes$6.hidden);
          selectEl.classList.toggle(classes$6.open);
        };
        options.forEach((option, i) => {
          if (i === 0) return;
          let optionInner = '';
          let notifyLabel = option.dataset.notifyLabel;
          let preorderLabel = option.dataset.pol;
          item = document.createElement('div');
          item.addEventListener('click', handleItemClick);
          item.setAttribute('class', 'p-select__item js-option ts-label-s');
          optionInner = `<span class="option">${option.innerHTML}</span>`;
          if (option.dataset.availability === 'false') {
            item.setAttribute('disabled', true);
            item.classList.add('is-disabled');
            optionInner = `<span class="option">${option.innerHTML}</span>
          <div class="option-message">
            <span>${notifyLabel}</span>
           ${envelope}
        </div>`;
          }
          if (option.dataset.availability === 'true' && 'pod' in option.dataset) {
            item.setAttribute('preorder', true);
            item.classList.add('is-preorder');
            optionInner = `<span class="option">${option.innerHTML}</span>
          <div class="option-message">
            <span>${preorderLabel}</span>
        </div>`;
          }
          item.innerHTML = optionInner;
          container.appendChild(item);
        });
        selectEl.insertBefore(selected, arrowIcon);
        selectEl.appendChild(container);
        selected.addEventListener('click', handleToggleList);
        return () => {
          selected.removeEventListener('click', handleToggleList);
        };
      };
      if (productDetails || searchResults) {
        initSelects();
      }
      window.addEventListener(events$2.PRODUCT_CARD_RENDERED, initSelects);
      return () => {
        instances.forEach(teardown => teardown());
      };
    };

    var fragmentOptionSelect$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentOptionSelect
    });

    const {
      breakpoints: breakpoints$3
    } = window.PoleneLibs.Breakpoints;
    const {
      getElementByRef: getElementByRef$6,
      getRefs: getRefs$5
    } = window.PoleneLibs.Refs;
    const selectors$3 = {
      item: '.js-item'
    };
    const classes$5 = {
      active: 'is-active',
      visible: 'is-visible'
    };
    var fragmentRevealableItems = () => {
      const {
        revealableItems
      } = getElementByRef$6('revealable-items');
      if (!revealableItems) return;
      const {
        contentContainer,
        titles,
        sliderTitles,
        descriptions
      } = getRefs$5(revealableItems);
      const init = () => {
        setContainerHeight(descriptions[0]);
      };
      const setContainerHeight = el => {
        contentContainer.style.setProperty('--el-height', el.scrollHeight + 'px');
      };
      const handleClick = e => {
        const isMobile = window.innerWidth < breakpoints$3.md;
        const item = e.target.closest(selectors$3.item);
        const currentIndex = item.dataset.index;
        const currentDescription = descriptions.find(description => description.dataset.index === currentIndex);
        let activeTopic;
        if (isMobile) {
          const {
            sliderTitles: activeTitle
          } = getRefs$5(item);
          sliderTitles.forEach(title => {
            title.classList.remove(classes$5.active);
          });
          activeTopic = activeTitle;
        } else {
          const {
            titles: activeTitle
          } = getRefs$5(item);
          titles.forEach(title => {
            title.classList.remove(classes$5.active);
          });
          activeTopic = activeTitle;
        }
        setContainerHeight(currentDescription);
        activeTopic.classList.add(classes$5.active);
        descriptions.forEach(description => {
          if (description == currentDescription) {
            description.classList.add(classes$5.visible);
          } else {
            description.classList.remove(classes$5.visible);
          }
        });
      };
      init();
      revealableItems.addEventListener('click', handleClick);
      return () => {
        revealableItems.removeEventListener('click', handleClick);
      };
    };

    var fragmentRevealableItems$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentRevealableItems
    });

    const {
      getElementsByRef: getElementsByRef$4
    } = window.PoleneLibs.Refs;
    const scrollLock$2 = window.PoleneLibs.ScrollLock.default;
    const classes$4 = {
      open: 'is-open',
      menuOpen: 'menu-open'
    };
    let isOpen = false;
    const update = ref => {
      if (!ref.searchOverlay || !ref.searchInput || !ref.siteHeader || !ref.menu || !ref.searchTrigger || !ref.searchOverlayBackdrop) return;
      const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
      if (Array.isArray(ref.searchOverlay)) return;
      ref.searchOverlay.classList.toggle(classes$4.open, isOpen);
      elements.forEach(element => {
        element.classList.toggle('is-active', isOpen);
      });
      scrollLock$2(isOpen);
      if (isOpen && !Array.isArray(ref.searchInput) && !Array.isArray(ref.siteHeader) && !Array.isArray(ref.menu) && !Array.isArray(ref.searchOverlayBackdrop)) {
        ref.searchInput.focus();
        ref.searchInput.select();
        ref.siteHeader.style.backgroundColor = 'hsl(var(--white))';
        ref.menu.classList.remove(classes$4.open);
        ref.siteHeader.classList.remove(classes$4.menuOpen);
        document.body.classList.add('search-open');
        ref.searchOverlayBackdrop.classList.add('is-open');
      } else if (!Array.isArray(ref.siteHeader) && !Array.isArray(ref.searchOverlayBackdrop)) {
        ref.siteHeader.style.removeProperty('background-color');
        document.body.classList.remove('search-open');
        ref.searchOverlayBackdrop.classList.remove('is-open');
      }
    };
    const setSearchOverlayOpenState = (ref, doOpen) => {
      if (doOpen === undefined) {
        isOpen = !isOpen;
      } else {
        isOpen = doOpen;
      }
      update(ref);
    };
    var fragmentSearchTrigger = () => {
      const ref = getElementsByRef$4(['search-trigger', 'search-overlay', 'search-input', 'site-header', 'menu', 'search-overlay-backdrop']);
      if (!ref.searchTrigger) return;
      const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
      const handleClick = () => setSearchOverlayOpenState(ref);
      const handleKeypress = e => {
        if (e.key !== 'Escape') return;
        setSearchOverlayOpenState(ref, false);
      };
      update(ref);
      const teardowns = elements.map(element => {
        element.addEventListener('click', handleClick);
        return () => element.removeEventListener('click', handleClick);
      });
      window.addEventListener('keydown', handleKeypress);
      if (ref.searchOverlayBackdrop && ref.searchOverlayBackdrop instanceof HTMLElement) {
        ref.searchOverlayBackdrop.addEventListener('click', () => setSearchOverlayOpenState(ref, false));
      }
      return () => {
        teardowns.forEach(teardown => teardown());
        window.removeEventListener('keydown', handleKeypress);
        setSearchOverlayOpenState(ref, false);
        if (ref.searchOverlayBackdrop && ref.searchOverlayBackdrop instanceof HTMLElement) {
          ref.searchOverlayBackdrop.removeEventListener('click', () => setSearchOverlayOpenState(ref, false));
        }
      };
    };

    var fragmentSearchTrigger$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSearchTrigger,
        setSearchOverlayOpenState: setSearchOverlayOpenState
    });

    const {
      getElementByRef: getElementByRef$5,
      getRefs: getRefs$4
    } = window.PoleneLibs.Refs;
    const scrollLock$1 = window.PoleneLibs.ScrollLock.default;
    const selectors$2 = {
      navItem: '.js-nav-item'
    };
    const classes$3 = {
      hasChildList: 'has-active-child',
      subMenuOpen: 'open-sub-menu',
      open: 'is-open',
      current: 'is-current'
    };
    var fragmentSubMenu = () => {
      const {
        subMenu,
        subMenuClose
      } = getElementByRef$5(['sub-menu', 'sub-menu-close']);
      if (!subMenu || !subMenuClose) return;
      const {
        activeMenus
      } = getRefs$4(subMenu);
      const activeItems = activeMenus ? [...activeMenus] : [];
      const init = () => {
        subMenu.addEventListener('click', handleClick);
        window.addEventListener('resize', closeMenu);
        if (subMenuClose) {
          subMenuClose.addEventListener('click', handleClose);
        }
      };
      const handleClose = () => {
        closeMenu();
      };
      const handleClick = e => {
        e.preventDefault();
        const subMenu = activeItems.length ? activeItems[activeItems.length - 1].parentNode : null;
        const navItem = e.target.closest(selectors$2.navItem);
        if (navItem && !navItem.classList.contains(classes$3.current) && !navItem.classList.contains(classes$3.hasChildList)) {
          const links = navItem.getElementsByTagName('a');
          const url = links[0].getAttribute('href');
          window.location.href = url;
          closeMenu();
        }
        if (!subMenu) return;
        if (subMenu.classList.contains(classes$3.open)) {
          subMenu.classList.remove(classes$3.open);
          document.body.classList.remove(classes$3.subMenuOpen);
          scrollLock$1(false);
        } else {
          subMenu.classList.add(classes$3.open);
          document.body.classList.add(classes$3.subMenuOpen);
          scrollLock$1(true);
        }
      };
      const closeMenu = () => {
        if (activeItems.length > 0) {
          activeItems.forEach(item => {
            item.parentNode.classList.remove(classes$3.open);
          });
        }
        document.body.classList.remove(classes$3.subMenuOpen);
        scrollLock$1(false);
      };
      init();
      return () => {
        subMenu.removeEventListener('click', handleClick);
        window.removeEventListener('resize', closeMenu);
        if (subMenuClose) {
          subMenuClose.removeEventListener('click', handleClose);
        }
      };
    };

    var fragmentSubMenu$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSubMenu
    });

    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef: getElementsByRef$3,
      getRefs: getRefs$3
    } = window.PoleneLibs.Refs;
    const zeroPad = x => x.toString().padStart(2, '0');
    const parseBool = str => str && str === 'true' ? true : false;
    const parseTime = time => {
      const minutes = Math.floor(time / 60);
      const seconds = Math.round(time - minutes * 60);
      return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
    };
    var fragmentVideo = () => {
      const {
        video,
        videoNative
      } = getElementsByRef$3(['video', 'video-native']);
      if (!video) return;
      const videos = Array.isArray(video) ? [...video] : [video];
      const handleIntersection = entries => {
        entries.forEach(entry => {
          const {
            isIntersecting,
            target
          } = entry;
          if (isIntersecting) {
            target.src = target.dataset.src;
            observer.unobserve(target);
          }
        });
      };
      const observer = intersection(null, handleIntersection, {
        rootMargin: `500px 0px 500px 0px`,
        threshold: [0]
      });
      if (videoNative) {
        const videos = videoNative ? Array.isArray(videoNative) ? [...videoNative] : [videoNative] : [];
        videos.forEach(videoNative => {
          observer.observe(videoNative);
        });
      }
      videos.map(video => {
        const refs = getRefs$3(video);
        if (refs.vimeoPlayer) {
          const options = {
            ...(refs.vimeoPlayer.dataset.vimeoUrl.includes('vimeo.com') ? {
              url: refs.vimeoPlayer.dataset.vimeoUrl
            } : {
              id: refs.vimeoPlayer.dataset.vimeoUrl
            }),
            byline: false,
            portrait: false,
            title: false,
            responsive: true
          };
          const player = new Vimeo.Player(refs.vimeoPlayer.id, options);
          let duration = 0;
          player.on('timeupdate', e => {
            duration = e.duration;
            if (refs.currentTime) refs.currentTime.textContent = parseTime(e.duration * e.percent);
            if (refs.duration) refs.duration.textContent = parseTime(e.duration);
            if (refs.timeline) {
              refs.timeline.value = e.percent;
              refs.timeline.style.setProperty('--progress', e.percent);
            }
          });
          player.on('volumechange', e => {
            if (refs.volume) refs.volume.value = e.volume;
            if (volume) volume.style.setProperty('--progress', e.volume);
          });
          player.on('loaded', async () => {
            const initVolume = await player.getVolume();
            if (refs.play) refs.play.textContent = parseBool(refs.vimeoPlayer.dataset.vimeoAutoplay) ? 'Pause' : 'Play';
            if (refs.volume) {
              refs.volume.value = initVolume;
              refs.volume.style.setProperty('--progress', initVolume);
            }
          });
          const handlePlay = async ({
            target
          }) => {
            if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
            if (await player.getPaused()) {
              player.play();
              if (refs.play) refs.play.textContent = 'Pause';
            } else {
              player.pause();
              if (refs.play) refs.play.textContent = 'Play';
            }
          };
          const handleSeek = e => {
            player.setCurrentTime(parseFloat(e.target.value) * duration);
            if (refs.timeline) refs.timeline.style.setProperty('--progress', parseFloat(e.target.value));
          };
          const handleVolume = e => {
            player.setVolume(parseFloat(e.target.value));
            if (refs.volume) {
              refs.volume.style.setProperty('--progress', parseFloat(e.target.value));
            }
          };
          const handleMute = async () => {
            const volume = await player.getVolume();
            if (refs.mute) {
              if (volume > 0.5) {
                player.setVolume(0);
                refs.mute.dataset.state = 'unmute';
              } else {
                player.setVolume(1);
                refs.mute.dataset.state = 'mute';
              }
            }
          };
          refs.play?.addEventListener('click', handlePlay);
          refs.vimeoPlayer?.addEventListener('click', handlePlay);
          refs.timeline?.addEventListener('input', handleSeek);
          refs.volume?.addEventListener('input', handleVolume);
          refs.mute?.addEventListener('input', handleMute);
        }
        if (refs.videoNative) {
          let isPlaying = parseBool(refs.videoNative.getAttribute('muted')) && parseBool(refs.videoNative.getAttribute('autoplay'));
          let progress = 0;
          const updateUI = () => {
            progress = refs.videoNative.currentTime / refs.videoNative.duration;
            if (refs.timeline) {
              refs.timeline.style.setProperty('--progress', parseFloat(progress.toString()));
              refs.timeline.value = parseFloat(progress.toString());
            }
            if (refs.volume) {
              refs.volume.value = refs.videoNative.muted ? 0 : refs.videoNative.volume;
              refs.volume.style.setProperty('--progress', parseFloat(refs.volume.value));
            }
            if (refs.currentTime) {
              refs.currentTime.textContent = parseTime(refs.videoNative.currentTime);
            }
            if (refs.duration) {
              refs.duration.textContent = parseTime(refs.videoNative.duration);
            }
            if (refs.mute) {
              if (refs.videoNative.muted) {
                refs.mute.dataset.state = 'unmute';
              } else {
                refs.mute.dataset.state = 'mute';
              }
            }
            if (refs.play) {
              if (isPlaying) {
                refs.play.textContent = 'Pause';
              } else {
                refs.play.textContent = 'Play';
              }
            }
            if (isPlaying) requestAnimationFrame(updateUI);
          };
          updateUI();
          const handlePlay = ({
            target
          }) => {
            if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
            isPlaying = !isPlaying;
            if (isPlaying) {
              refs.videoNative.play();
            } else {
              refs.videoNative.pause();
            }
            updateUI();
          };
          const handleSeek = e => {
            refs.videoNative.currentTime = e.target.value * refs.videoNative.duration;
            updateUI();
          };
          const handleVolume = e => {
            refs.videoNative.muted = false;
            refs.videoNative.volume = e.target.value;
            updateUI();
          };
          const handleMute = () => {
            const muted = parseBool(refs.videoNative.getAttribute('muted'));
            refs.videoNative.setAttribute('muted', !muted);
            refs.videoNative.muted = !muted;
            updateUI();
          };
          if (refs.play) {
            video?.addEventListener('click', handlePlay);
          }
          refs.volume?.addEventListener('input', handleVolume);
          refs.mute?.addEventListener('click', handleMute);
          refs.timeline?.addEventListener('input', handleSeek);
        }
      });
    };

    var fragmentVideo$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentVideo
    });

    const camelCase = s => s.replace(/-./g, x => x[1].toUpperCase());
    const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
    function groupByRef(element, result, onlyFirst = false) {
      const ref = element.getAttribute('data-ref');
      if (!ref) return;
      const refs = ref.split(' ').map(camelCase);
      refs.forEach(capitalizedRef => {
        if (onlyFirst) {
          if (!result[capitalizedRef]) {
            result[capitalizedRef] = element;
          }
        } else {
          if (result[capitalizedRef]) {
            if (Array.isArray(result[capitalizedRef])) {
              result[capitalizedRef].push(element);
            } else {
              result[capitalizedRef] = [result[capitalizedRef], element];
            }
          } else {
            result[capitalizedRef] = element;
          }
        }
      });
    }
    const getElementsByRef$2 = (refs, target) => {
      const root = target instanceof HTMLElement ? target : document.body;
      const result = {};
      const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref*="${ref}"]`).join(',') : `[data-ref*="${refs}"]`;
      const elements = root.querySelectorAll(selector);
      elements.forEach(element => groupByRef(element, result));
      return result;
    };
    const getRefs$2 = (target = document.body, watch) => {
      const root = typeof target === 'string' ? document.querySelector(`[data-namespace="${target}"]`) : target;
      if (!root) {
        return;
      }
      const name = root?.getAttribute('data-namespace');
      return watch ? _watched(root, name, watch) : _refs(root, name, true);
    };
    function _refs(root, name, includeRoot) {
      const attribute = name ? `data-ref-${name}` : 'data-ref';
      return [...root.querySelectorAll(`[${attribute}]`)].reduce((refs, el) => {
        const dataset = name ? `ref${capitalize(name)}` : 'ref';
        return {
          ...(includeRoot && {
            root
          }),
          ...refs,
          ...(camelCase(el.dataset[dataset]) || 'item').split(' ').reduce((acc, newRef) => ({
            ...acc,
            [newRef]: refs[newRef] ? [refs[newRef], el].flat() : el
          }), {})
        };
      }, {});
    }
    function _watched(r, n, onChange) {
      const observer = new MutationObserver(() => {
        ref.current = _refs(r, n);
        typeof onChange === 'function' && onChange();
      });
      observer.observe(r, {
        childList: true,
        subtree: true
      });
      const ref = {
        root: r,
        current: _refs(r, n),
        unwatch: observer.disconnect.bind(observer)
      };
      return ref;
    }
    getRefs$2();

    var imageLoaded = () => {
      const {
        image,
        video
      } = getElementsByRef$2(['image', 'video']);
      const images = image ? Array.isArray(image) ? image : [image] : [];
      const videos = video ? Array.isArray(video) ? video : [video] : [];
      const handleImageLoad = ({
        target
      }) => {
        target.classList.add('loaded');
      };
      images.forEach(image => {
        if (image.complete) {
          handleImageLoad({
            target: image
          });
        } else {
          image.addEventListener('load', handleImageLoad, {
            once: true
          });
        }
      });
      videos.forEach(video => {
        video.addEventListener('canplaythrough', handleImageLoad);
        setTimeout(() => {
          handleImageLoad({
            target: video
          });
        }, 1000);
      });
    };

    var imageLoaded$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: imageLoaded
    });

    const breakpoints$2 = {
      'sm': 600,
      'md': 1024,
      'lg': 1200,
      'xl': 1440,
      'page-max': 1660
    };

    const progress = (() => {
      const multiplier = 0.1;
      let instances = [];
      window.ins = instances;
      let ticking = false;
      let raf = null;
      const start = () => {
        ticking = true;
        animate();
      };
      const pause = () => {
        ticking = false;
        if (raf) cancelAnimationFrame(raf);
      };
      const destroy = () => {
        pause();
        instances = [];
      };
      const isAnimating = () => {
        return ticking;
      };
      const add = ({
        element,
        value
      }) => {
        const valueAsFloat = value;
        const bounds = element.getBoundingClientRect();
        const startFromZero = bounds.y + bounds.height + scrollY >= 0 && bounds.y + scrollY < innerHeight ? true : false;
        const initialProgressInScreen = Math.max((innerHeight - bounds.y - scrollY) / (innerHeight + bounds.height), 0);
        let startValue = 0;
        let endValue = 0;
        if (startFromZero) {
          startValue = 0;
        } else {
          startValue = valueAsFloat * -0.5;
        }
        endValue = valueAsFloat * 0.5;
        const instance = {
          element,
          startValue,
          endValue,
          range: endValue - startValue,
          currentValue: null,
          initialProgressInScreen,
          isInitialized: false
        };
        instances.push(instance);
        if (!ticking) {
          start();
        }
      };
      const animate = () => {
        const {
          innerHeight
        } = window;
        let instancesLength = instances.length;
        let i = instancesLength;
        if (raf) {
          cancelAnimationFrame(raf);
        }
        if (ticking) {
          raf = requestAnimationFrame(animate);
        }
        while (i) {
          i--;
          const instance = instances[i];
          const {
            element,
            startValue,
            endValue,
            initialProgressInScreen,
            isInitialized
          } = instance;
          const bounds = element.getBoundingClientRect();
          let progress = (innerHeight - bounds.y) / (innerHeight + bounds.height);
          let normalizedProgress = (progress - initialProgressInScreen) / (1 - initialProgressInScreen);
          if (normalizedProgress > 1) normalizedProgress = 1;
          if (normalizedProgress < 0) normalizedProgress = 0;
          if (normalizedProgress === 0 && instance.currentValue === startValue) continue;
          if (normalizedProgress >= 1 && instance.currentValue === endValue) continue;
          const targetValue = (endValue - startValue) * normalizedProgress + startValue;
          const delta = targetValue - (instance.currentValue ?? 0);
          const velocity = Math.abs(delta) < 0.1 ? 0 : delta * multiplier;
          instance.currentValue = (instance.currentValue ?? 0) + velocity;
          instance.currentValue = parseFloat(instance.currentValue.toFixed(3));
          if (Math.abs(delta) < 0.1 || !isInitialized) {
            instance.currentValue = parseFloat(targetValue.toFixed(3));
            instance.isInitialized = true;
          }
          const transformString = `translate3d(0, ${instance.currentValue}px,0)`;
          setTransform(element, transformString);
        }
      };
      const setTransform = (element, transform) => {
        element.style.transform = transform;
      };
      return {
        start,
        pause,
        destroy,
        isAnimating,
        add
      };
    })();

    var parallax = () => {
      const ref = getElementsByRef$2(['parallax-el']);
      if (!ref?.parallaxEl) return;
      const parallaxItems = Array.isArray(ref.parallaxEl) ? ref.parallaxEl : [ref.parallaxEl];
      let items = [];
      let isMobile = window.innerWidth < breakpoints$2.md;
      const init = () => {
        window.addEventListener('load', isReady);
      };
      const isReady = () => {
        items = isMobile ? parallaxItems.filter(item => !item.hasAttribute('data-disable-mobile-parallax')) : parallaxItems;
        items.forEach(item => {
          progress.add({
            element: item,
            value: item.dataset.parallax ? parseFloat(item.dataset.parallax) : 0
          });
        });
      };
      init();
      return () => {
        window.removeEventListener('load', isReady);
        progress.destroy();
      };
    };

    var parallax$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: parallax
    });

    const events$1 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$4
    } = window.PoleneLibs.Refs;
    const classes$2 = {
      announcementBarActive: 'announcement-bar-active',
      appear: 'appear'
    };
    var sectionAnnouncementBar = () => {
      const {
        announcementBar,
        siteHeader
      } = getElementByRef$4(['announcement-bar', 'site-header']);
      if (!announcementBar || !siteHeader) return;
      const init = () => {
        document.body.style.setProperty('--header-top-pos', '30px');
        siteHeader.classList.add(classes$2.announcementBarActive);
        document.body.classList.add(classes$2.announcementBarActive);
        announcementBar.classList.add(classes$2.appear);
        dispatchEvent(window, events$1.ANNOUNCEMENT_BAR_RENDERED);
      };
      init();
    };

    var sectionAnnouncementBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionAnnouncementBar
    });

    const {
      breakpoints: breakpoints$1
    } = window.PoleneLibs.Breakpoints;
    const {
      getElementsByRef: getElementsByRef$1,
      getRefs: getRefs$1
    } = window.PoleneLibs.Refs;
    const selectors$1 = {
      item: '.js-teaser-item'
    };
    const classes$1 = {
      reveal: 'reveal',
      active: 'is-active'
    };
    var sectionArticleTeaser = () => {
      const {
        articleTeaser
      } = getElementsByRef$1(['article-teaser']);
      if (!articleTeaser) return;
      const articleTeasers = Array.isArray(articleTeaser) ? articleTeaser : [articleTeaser];
      articleTeasers.forEach(teaser => {
        let interval;
        let currentIdx = 0;
        let lastIdx = 0;
        let mobileIndex = 0;
        let mobileInterval;
        const {
          previewImages,
          items,
          articleTeaserItem
        } = getRefs$1(teaser);
        const init = () => {
          setEventlisteners();
        };
        const setEventlisteners = () => {
          teaser.addEventListener('mouseover', handleMouseOver);
        };
        const handleMouseOver = e => {
          const item = e.target instanceof Element ? e.target.closest(selectors$1.item) : null;
          if (item) {
            const activeIdx = item.dataset.index ? item.dataset.index : 0;
            const links = items ? Array.from(items) : [];
            links.forEach(link => {
              if (link == item) {
                link.classList.add(classes$1.active);
              } else {
                link.classList.remove(classes$1.active);
              }
            });
            if (lastIdx === activeIdx) return;
            lastIdx = activeIdx;
            stopCounter();
            revealImage(previewImages, activeIdx);
            if (item.dataset.imageAmount) {
              const imageAmount = item.dataset.imageAmount;
              const preview = previewImages.find(p => p?.dataset?.index === activeIdx);
              const {
                revealImages
              } = getRefs$1(preview);
              if (revealImages.length) {
                revealImage(revealImages, 0);
                interval = setInterval(() => {
                  if (currentIdx == imageAmount - 1) {
                    currentIdx = 0;
                  } else {
                    currentIdx = currentIdx + 1;
                  }
                  revealImage(revealImages, currentIdx);
                }, 1800);
              }
            }
          }
        };
        const stopCounter = () => {
          clearInterval(interval ?? undefined);
        };
        if (window.innerWidth <= breakpoints$1.md) {
          const updateClasses = () => {
            previewImages.forEach((item, idx) => {
              const reveal = idx === mobileIndex;
              item.classList.toggle('reveal', reveal);
              item.firstElementChild?.classList.add('reveal');
              articleTeaserItem[idx].classList.toggle('reveal', reveal);
            });
          };
          updateClasses();
          mobileInterval = setInterval(() => {
            mobileIndex = (mobileIndex + 1) % previewImages.length;
            updateClasses();
          }, 3200);
        }
        const revealImage = (images, idx) => {
          images.forEach(img => {
            if (img.dataset.index == idx) {
              img.classList.add(classes$1.reveal);
            } else {
              img.classList.remove(classes$1.reveal);
            }
          });
        };
        init();
        return () => {
          teaser.removeEventListener('mouseover', handleMouseOver);
          if (mobileInterval) clearInterval(mobileInterval);
        };
      });
    };

    var sectionArticleTeaser$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionArticleTeaser
    });

    const {
      breakpoints
    } = window.PoleneLibs.Breakpoints;
    const events = window.PoleneLibs.Events.default;
    const scrollLock = window.PoleneLibs.ScrollLock.default;
    const {
      getElementByRef: getElementByRef$3,
      getRefs,
      ref
    } = window.PoleneLibs.Refs;
    const KeyboardNavigationHook = window.PoleneLibs.KeyboardNavigationHook;
    const selectors = {
      item: '.js-item',
      menuToggle: '.js-menu-toggle',
      faveCounter: '.js-fave-counter',
      subNavTitle: '.js-sub-nav-title'
    };
    const classes = {
      item: 'js-item',
      menuOpen: 'menu-open',
      scrolled: 'is-scrolled',
      open: 'is-open',
      announcementBarActive: 'announcement-bar-active',
      reveal: 'reveal',
      active: 'is-active'
    };
    const isMobile = () => window.innerWidth < breakpoints.md;
    const isSmall = () => window.innerWidth < breakpoints.sm;
    const isScrolled = (scrollHeight = null) => window.scrollY > (isMobile() ? 0 : scrollHeight ?? 80);
    var sectionHeader = () => {
      const {
        siteHeader,
        closeMenu
      } = getElementByRef$3(['site-header', 'close-menu']);
      if (!siteHeader || !closeMenu) return;
      const hasAnnouncementBar = siteHeader?.classList.contains(classes.announcementBarActive);
      const {
        menu,
        menuItem,
        imageLink,
        hoverImg,
        subNavTitle
      } = getRefs(siteHeader);
      const headerItems = Array.from(menu.querySelectorAll('li[data-level="1"]'));
      const imageLinks = imageLink ? [].concat(imageLink) : [];
      const hoverImages = hoverImg ? [].concat(hoverImg) : [];
      const menuItems = menuItem ? [].concat(menuItem) : [];
      const subNavTitles = subNavTitle ? [].concat(subNavTitle) : [];
      let timer = null;
      let activeDropdown = null;
      let activeContainer = null;
      let triggerElem = null;
      let containerFocusable = null;
      const init = () => {
        setEventListeners();
        handleScroll();
      };
      const handleResize = () => {
        handleScroll();
      };
      const setEventListeners = () => {
        window.addEventListener('scroll', handleScroll, {
          passive: true
        });
        window.addEventListener('resize', handleResize, {
          passive: true
        });
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener(events.CART_UPDATED, updateCartCount);
        window.addEventListener(events.ANNOUNCEMENT_BAR_RENDERED, setCSSVariables);
        menuItems.forEach(item => {
          if (item.classList.contains(classes.active) && isMobile()) {
            if (item.dataset.level == '3') {
              const firstLevel = item.closest('[data-level="1"]');
              const subNav = item.closest('ul');
              const secondLevel = subNav?.previousElementSibling;
              firstLevel?.setAttribute('aria-expanded', 'true');
              secondLevel && subNav && toggleSubNav(secondLevel, subNav);
            } else {
              item.setAttribute('aria-expanded', 'true');
            }
          }
          if (item.dataset.level === '1' && item.dataset.children && +item.dataset.children > 0) {
            item.addEventListener('mouseenter', handleOpenDropdown);
            item.addEventListener('mouseleave', handleCloseDropdown);
            item.addEventListener('click', handleToggleNextLevel);
          }
          if (item.dataset.level === '2') {
            item.addEventListener('click', handleOpenSubNav);
          }
        });
        subNavTitles.forEach(title => {
          title.addEventListener('click', handleCloseSubNav);
        });
        imageLinks.forEach(link => {
          link.addEventListener('mouseenter', e => handleRevealImage(e, true));
          link.addEventListener('mouseleave', e => handleRevealImage(e, false));
        });
        if (closeMenu) {
          closeMenu.addEventListener('click', handleClose);
        }
        siteHeader?.addEventListener('click', handleClick);
      };
      const onKeyboardNavigation = () => {
        headerItems.forEach(item => {
          if (item.getAttribute('data-children') === '0') return;
          const element = item.querySelector('a[data-ref="menu-link"]');
          if (!element) return;
          element.setAttribute('data-url', element.href);
          element.removeAttribute('href');
          element.setAttribute('dataindex', '-1');
          element.classList.add('disabled');
        });
      };
      const onMouseNavigation = () => {
        headerItems.forEach(item => {
          if (item.getAttribute('data-children') === '0') return;
          const element = item.querySelector('a[data-ref="menu-link"]');
          setTimeout(() => {
            if (!element || !element.dataset.url) return;
            element.setAttribute('href', element.dataset.url);
            element.removeAttribute('dataindex');
            element.classList.remove('disabled');
          }, 50);
        });
      };
      const keyboardNavHook = new KeyboardNavigationHook({
        onKeyboardEvent: onKeyboardNavigation,
        onMouseEvent: onMouseNavigation
      });
      const handleToggleNextLevel = e => {
        if (!isMobile()) return;
        const target = e.target;
        const item = target?.closest(selectors.item);
        const subNavTitle = target?.closest(selectors.subNavTitle);
        if (subNavTitle || document.body.classList.contains('search-open')) return;
        item?.setAttribute('aria-expanded', 'true');
      };
      const handleOpenSubNav = e => {
        const item = e.currentTarget;
        const subNav = item?.nextElementSibling;
        item && subNav && toggleSubNav(item, subNav);
      };
      const toggleSubNav = (item, subNav) => {
        const expanded = subNav.getAttribute('aria-expanded');
        if (expanded === 'false') {
          subNav.style.maxHeight = subNav.scrollHeight + 'px';
          subNav.style.opacity = '1';
          subNav.setAttribute('aria-expanded', 'true');
          item.classList.add(classes.open);
        } else {
          subNav.style.maxHeight = '0px';
          subNav.style.opacity = '0';
          subNav.setAttribute('aria-expanded', 'false');
          item.classList.remove(classes.open);
        }
      };
      const handleCloseSubNav = () => {
        menuItems.forEach(item => {
          item.setAttribute('aria-expanded', 'false');
        });
      };
      const handleOpenDropdown = e => {
        if (!isMobile() && !document.body.classList.contains('search-open')) {
          timer && clearTimeout(timer);
          if (activeDropdown && activeDropdown !== e.target) {
            menuItems.forEach(item => {
              item.setAttribute('aria-expanded', 'false');
            });
          }
          const target = e.target;
          const targetItem = target.tagName != 'LI' ? target.closest('li') : target;
          if (target.tagName != 'LI') triggerElem = targetItem;
          activeDropdown = targetItem;
          activeDropdown?.setAttribute('aria-expanded', 'true');
          siteHeader?.classList.add(classes.menuOpen);
          document.body.classList.add(classes.menuOpen);
          activeContainer = activeDropdown?.querySelector('div[data-ref="nav-containers"]');
          if (!activeContainer) return;
          containerFocusable = Array.from(activeContainer.querySelectorAll('a.ts-tertiary-item'));
          if (containerFocusable.length > 0) containerFocusable[0].focus();
        }
      };
      const handleCloseDropdown = e => {
        if (!isMobile()) {
          timer && clearTimeout(timer);
          timer = window.setTimeout(() => {
            e.target?.setAttribute('aria-expanded', 'false');
            siteHeader?.classList.remove(classes.menuOpen);
            document.body.classList.remove(classes.menuOpen);
            activeDropdown = null;
          }, 200);
          activeContainer = null;
          containerFocusable = [];
          if (triggerElem) {
            triggerElem.focus();
            triggerElem = null;
          }
        }
      };
      const handleRevealImage = (e, reveal) => {
        hoverImages.forEach(img => {
          if (img.dataset.media === e.target?.dataset.handle) {
            if (reveal) {
              img.classList.add(classes.reveal);
            } else {
              img.classList.remove(classes.reveal);
            }
          }
        });
      };
      const handleClose = () => {
        menu?.classList.remove(classes.open);
        document.body.classList.remove(classes.open);
        siteHeader?.classList.remove(classes.menuOpen);
        document.body.classList.remove(classes.menuOpen);
        scrollLock(false);
      };
      const handleClick = e => {
        const menuTriggered = menu.contains(document.activeElement);
        const toggle = e.target?.closest(selectors.menuToggle);
        const isMenuOpen = siteHeader?.classList.contains(classes.menuOpen);
        if (menuTriggered && document.activeElement?.hasAttribute('aria-expanded')) handleOpenDropdown(e);
        if (toggle) {
          const header = siteHeader;
          menu?.classList.toggle(classes.open);
          header?.classList.toggle(classes.menuOpen);
          document.body.classList.toggle(classes.open);
          document.body.classList.toggle(classes.menuOpen);
          setSearchOverlayOpenState(ref, false);
          handleColorTheme(!isMenuOpen);
          scrollLock(!isMenuOpen);
        }
      };
      const handleColorTheme = menuOpen => {
        const pageColor = document.body.classList.contains('theme-beige') ? '#EDEAE7' : 'transparent';
        const metaThemeColor = document.querySelector("meta[name='theme-color']");
        if (!metaThemeColor) return;
        if (menuOpen) {
          metaThemeColor.content = '#fff';
        } else {
          metaThemeColor.content = pageColor;
        }
      };
      const handleScroll = () => {
        siteHeader?.classList.toggle(classes.scrolled, isScrolled(hasAnnouncementBar ? 30 : null));
        document.body.classList.toggle(classes.scrolled, isScrolled(hasAnnouncementBar ? 30 : null));
        setCSSVariables();
        setProductDetailsMarginTopCssVariable();
      };
      const handleKeyDown = event => {
        if (event.key === 'Enter') {
          const target = event.target;
          if (target.hasAttribute('aria-expanded')) {
            triggerElem = target;
            handleOpenDropdown(event);
          }
        }
        if (event.key === 'Escape') {
          handleCloseDropdown(event);
          handleCloseSubNav();
        }
        if (event.key == 'Tab') handleTab(event);
      };
      const handleTab = event => {
        if (!containerFocusable) return;
        const isReverseTabbing = event.shiftKey;
        const firstElement = containerFocusable[0];
        const lastElement = containerFocusable[containerFocusable.length - 1];
        const isLeavingDropdown = event.target == firstElement && isReverseTabbing || event.target == lastElement && !isReverseTabbing;
        if (isLeavingDropdown) {
          event.preventDefault();
          triggerElem?.focus();
          handleCloseDropdown(event);
          handleCloseSubNav();
        }
      };
      const calculateTotalHeight = element => {
        if (!element) return 0;
        const rect = element.getBoundingClientRect();
        return Math.floor(rect.height);
      };
      const setCSSVariables = () => {
        const {
          height
        } = siteHeader.getBoundingClientRect();
        const translate = !isScrolled() || isSmall() ? 0 : 20;
        const headerHeight = `${height - translate}px`;
        const fullHeight = hasAnnouncementBar ? `${height - translate + 30}px` : `${height - translate}px`;
        const initHeaderHeight = hasAnnouncementBar ? `${height + 30}px` : `${height}px`;
        document.body.style.setProperty('--init-header-height', initHeaderHeight);
        document.body.style.setProperty('--header-height', headerHeight);
        document.body.style.setProperty('--full-header-height', fullHeight);
        document.body.style.setProperty('--full-height', `${window.innerHeight}px`);
      };
      const setProductDetailsMarginTopCssVariable = () => {
        const {
          height
        } = siteHeader.getBoundingClientRect();
        const translate = !isScrolled() || isSmall() ? 0 : 20;
        const productInfoHeader = document.querySelector('.product-hero-info__header');
        const productInfoMain = document.querySelector('.product-hero-info__main');
        const productInfoBottom = document.querySelector('.product-hero-info__bottom');
        const totalHeight = calculateTotalHeight(productInfoHeader) + calculateTotalHeight(productInfoMain) + calculateTotalHeight(productInfoBottom);
        document.body.style.setProperty('--product-details-margin-top', `${Math.max(0, totalHeight + 55 + (hasAnnouncementBar ? height - translate + 30 : height - translate) - window.innerHeight)}px`);
      };
      const updateCartCount = () => {
        fetchCart();
      };
      init();
      return () => {
        window.removeEventListener(events.CART_UPDATED, updateCartCount);
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
        siteHeader?.removeEventListener('click', handleClick);
        menuItems.forEach(item => {
          if (item.dataset.level === '1' && item.dataset.children && +item.dataset.children > 0) {
            item.removeEventListener('mouseenter', handleOpenDropdown);
            item.removeEventListener('mouseleave', handleCloseDropdown);
            item.removeEventListener('click', handleToggleNextLevel);
          }
          if (item.dataset.level === '2') {
            item.removeEventListener('click', handleOpenSubNav);
          }
        });
        subNavTitles.forEach(title => {
          title.removeEventListener('click', handleCloseSubNav);
        });
        imageLinks.forEach(link => {
          const handleMouseEnter = e => handleRevealImage(e, true);
          const handleMouseLeave = e => handleRevealImage(e, false);
          link.removeEventListener('mouseenter', handleMouseEnter);
          link.removeEventListener('mouseleave', handleMouseLeave);
        });
        if (closeMenu) {
          closeMenu.removeEventListener('click', handleClose);
        }
        keyboardNavHook.stop();
      };
    };

    var sectionHeader$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionHeader
    });

    const {
      getElementsByRef,
      getElementByRef: getElementByRef$2
    } = window.PoleneLibs.Refs;
    var sectionCountdownTeaser = () => {
      const {
        countdownTeaser
      } = getElementsByRef('countdown-teaser');
      if (!countdownTeaser) return;
      const countdownTeasers = Array.isArray(countdownTeaser) ? countdownTeaser : [countdownTeaser];
      const cleaners = [];
      countdownTeasers.forEach(teaser => {
        const {
          days,
          hours,
          minutes,
          seconds
        } = getElementByRef$2(['days', 'hours', 'minutes', 'seconds'], teaser);
        const {
          targetDate
        } = teaser.dataset;
        if (!days || !hours || !minutes || !seconds || !targetDate) return;
        const target = new Date(targetDate).getTime();
        if (isNaN(target)) return;
        const updateCountdown = () => {
          const now = Date.now();
          let diff = target - now;
          if (diff <= 0) {
            days.textContent = '00';
            hours.textContent = '00';
            minutes.textContent = '00';
            seconds.textContent = '00';
            return;
          }
          const d = Math.floor(diff / (1000 * 60 * 60 * 24));
          diff -= d * (1000 * 60 * 60 * 24);
          const h = Math.floor(diff / (1000 * 60 * 60));
          diff -= h * (1000 * 60 * 60);
          const m = Math.floor(diff / (1000 * 60));
          diff -= m * (1000 * 60);
          const s = Math.floor(diff / 1000);
          days.textContent = String(d).padStart(2, '0');
          hours.textContent = String(h).padStart(2, '0');
          minutes.textContent = String(m).padStart(2, '0');
          seconds.textContent = String(s).padStart(2, '0');
        };
        updateCountdown();
        const intervalId = setInterval(updateCountdown, 1000);
        const cleanup = () => {
          clearInterval(intervalId);
        };
        cleaners.push(cleanup);
      });
      return () => cleaners.forEach(cleaner => cleaner());
    };

    var sectionCountdownTeaser$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionCountdownTeaser
    });

    const {
      relocateElementIfNeeded: relocateElementIfNeeded$1
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    const {
      morph: morph$1
    } = window.PoleneLibs.SectionRenderer;
    class ProductRecommendations extends HTMLElement {
      activeFetch = null;
      sectionId = undefined;
      productId = undefined;
      intent = undefined;
      recommendationsPerformed = false;
      url = undefined;
      cache = {};
      onlyWishlistEmpty = false;
      minQtyWishlist = 3;
      isFailover = false;
      slidesContainer = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        relocateElementIfNeeded$1(this);
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          sectionId,
          productId,
          recommendationsPerformed,
          url,
          intent,
          onlyWishlistEmpty,
          minQtyWishlist,
          isFailover
        } = this.dataset;
        const {
          sliderSlidesContainer
        } = getElementByRef$1('slider-slides-container', this);
        this.slidesContainer = sliderSlidesContainer;
        this.sectionId = sectionId;
        this.productId = productId;
        this.intent = intent;
        this.recommendationsPerformed = recommendationsPerformed === 'true';
        this.url = url;
        this.onlyWishlistEmpty = onlyWishlistEmpty === 'true';
        this.minQtyWishlist = !!minQtyWishlist ? +minQtyWishlist : this.minQtyWishlist;
        this.isFailover = isFailover === 'true';
        if (!this.recommendationsPerformed) this.render();
      };
      setupEventListeners = () => {
        if (this.onlyWishlistEmpty) Wishlist.setEventListeners(WishlistEvent.UPDATE, this.render);
      };
      removeEventListeners = () => {
        if (this.onlyWishlistEmpty) Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.render);
      };
      render = async () => {
        if (!this.slidesContainer) return;
        if (this.onlyWishlistEmpty && Wishlist.count() >= this.minQtyWishlist) {
          this.classList.remove('visible');
          return;
        }
        if (this.isFailover === true) {
          this.classList.add('visible');
          return;
        }
        const section = await this.requestSection();
        if (!section.success || !section.data) return;
        const parsedDoc = new DOMParser().parseFromString(section.data, 'text/html');
        const newSlidesContainer = parsedDoc.querySelector('[data-ref="slider-slides-container"]');
        if (newSlidesContainer) {
          morph$1(this.slidesContainer, newSlidesContainer);
          this.classList.add('visible');
        }
      };
      requestSection = async () => {
        const url = `${this.url}&product_id=${this.productId}&section_id=${this.sectionId}&intent=${this.intent}`;
        const cachedResponse = this.cache[url];
        if (cachedResponse) {
          return {
            success: true,
            data: cachedResponse
          };
        }
        this.activeFetch?.abort();
        this.activeFetch = new AbortController();
        try {
          const response = await fetch(url, {
            signal: this.activeFetch?.signal
          });
          if (!response.ok) return {
            success: false,
            status: response.status
          };
          const text = await response.text();
          this.cache[url] = text;
          return {
            success: true,
            data: text
          };
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            return {
              success: false,
              status: 0
            };
          }
          throw error;
        } finally {
          this.activeFetch = null;
        }
      };
      static define = () => {
        if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
      };
    }
    var sectionProductRecommendations = () => {
      ProductRecommendations.define();
    };

    var sectionProductRecommendations$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ProductRecommendations: ProductRecommendations,
        default: sectionProductRecommendations
    });

    const {
      relocateElementIfNeeded
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef
    } = window.PoleneLibs.Refs;
    const {
      morph
    } = window.PoleneLibs.SectionRenderer;
    class WishlistSlider extends HTMLElement {
      slidesContainer = undefined;
      minQtyWishlist = 3;
      constructor() {
        super();
      }
      connectedCallback() {
        relocateElementIfNeeded(this);
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          sliderSlidesContainer
        } = getElementByRef('slider-slides-container', this);
        const {
          minQtyWishlist
        } = this.dataset;
        this.slidesContainer = sliderSlidesContainer;
        this.minQtyWishlist = !!minQtyWishlist ? +minQtyWishlist : this.minQtyWishlist;
        if (this.slidesContainer) this.renderSlides();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.renderSlides);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.renderSlides);
      };
      renderSlides = async () => {
        if (!this.slidesContainer) return;
        const hasEnoughItems = Wishlist.count() >= this.minQtyWishlist;
        if (!hasEnoughItems) {
          this.classList.remove('visible');
          return;
        }
        const slides = await Wishlist.getHTML('slides');
        if (slides && slides.length > 1) {
          const parsedDoc = new DOMParser().parseFromString(slides, 'text/html');
          const tempContainer = this.slidesContainer.cloneNode(false);
          tempContainer.innerHTML = parsedDoc.body.innerHTML;
          morph(this.slidesContainer, tempContainer);
          this.classList.add('visible');
        } else {
          this.classList.remove('visible');
        }
      };
      static define = () => {
        if (!customElements.get('wishlist-slider')) customElements.define('wishlist-slider', WishlistSlider);
      };
    }
    var sectionWishlistSlider = () => {
      WishlistSlider.define();
    };

    var sectionWishlistSlider$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        WishlistSlider: WishlistSlider,
        default: sectionWishlistSlider
    });

})();
